var Cortona3DSolo = require('solo');
var Tiramisu = Module.Tiramisu;
var app = require('app').app;
var checkConfigureOptions = require('app').checkConfigureOptions;
var deface = require('lib/deface');
var millicolor = require('lib/color-object');

var util = require('lib/util'),
    expand = util.expand;

var base = require('./base'),
    unmarshalFloatArray = base.unmarshalFloatArray,
    unmarshalObjectArray = base.unmarshalObjectArray,
    assignVec3f = base.assignVec3f,
    toRotation = base.toRotation,
    dispatchMouseEvent = base.dispatchMouseEvent,
    getCameraOrientation = base.getCameraOrientation,
    getCanvasWithImageData = base.getCanvasWithImageData,
    unmarshalPickResult = base.unmarshalPickResult,
    unmarshalPickResults = base.unmarshalPickResults,
    withObjectHandles = base.withObjectHandles,
    createNavigationCubeCanvas = base.createNavigationCubeCanvas;

var navCube = require('./NavigationCube');
var Navigator = require('./Navigator');
var SectionPlane = require('./SectionPlane');

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent);

var NEED_WEBGL2 = 'WebGL 2.0 is required'

var Hammer = require('hammerjs');

var PRESS_TIME = 750;
var DOUBLE_TAP_TIME = 250;
var m_isPressed = false;

var MIN_PICKER_TRANSPARENCY_THRESHOLD = 1.1755e-38;
var m_fitFactorObject = 0.5;
var m_fitFactorScene = 0.95;

var m_didFinishLoadDocument = false;
var m_firstFrameDidArrive = false;
var m_doc;
var m_hiddenObjects = {};

var m_defaultBackgroundColors = [];
var m_recursiveObjectLookup = true;

var m_mouseEventTargets;

var m_navigationCube = {
    localizedText: navCube.kDefaultNavigationCubeText,
    style: {
        textColor: '#333',
        background: 'rgba(220,220,220,0.75)',
        border: 'rgba(64,64,64,0.75)',
        hoveredBackground: 'rgba(100,240,255,0.95)',
        hoveredBorder: 'rgba(80,180,200,1.0)'
    }
};

function beforeFirstFrameRender() {
    var didDrawScene = PanelService.didDrawScene;
    if (typeof didDrawScene === 'function') {
        PanelService.didDrawScene = function () {
            Cortona3DSolo.dispatch("core.didDrawAnimationFrame");
            didDrawScene.call(PanelService);
        };
    }
    var willDrawScene = PanelService.willDrawScene;
    if (typeof willDrawScene === 'function') {
        PanelService.willDrawScene = function () {
            Cortona3DSolo.dispatch("core.willDrawAnimationFrame");
            willDrawScene.call(PanelService);
        };
    }
    if (Module.Stella) {
        m_doc = {
            type: 'generic'
        };
    }
    var isGeneric = m_doc.type === 'generic';
    if (!isGeneric) {
        app.pickerTransparencyThreshold = 0;
    }
    app.ui.showCanvas(isGeneric || app.getChildObjects().length > 0);
    Cortona3DSolo.dispatch("core.didChangeLayout");
    app.ui.setBannerImage(app.util.fetchBannerImage());
}

// Tiramisu hooks
expand(Tiramisu, {
    didFinishLoadDocument: function (doc) {
        m_doc = doc;
        attachCanvasListeners();

        doc.baseURL = "";
        if (!doc.bundleURL) {
            doc.baseURL = base.getBaseURL(doc.companionFile || require('app').getDocumentURL());
        } else {
            doc.companionFile = encodeURI(doc.companionFile);
        }

        app.recursiveObjectLookup = (doc.type !== 'ipc' || app.getOption('keep3DStructure') === 'Yes');

        if (app.getOption('KeepSurfaceEdges') === 'Yes') {
            app.edgeColorWeights = [1, 0, 0];
        }

        attachInteractivityXML(doc).then(function () {
            var type = doc.type;
            m_didFinishLoadDocument = true;
            Cortona3DSolo.dispatch('app.didFinishLoadDocument', doc);
            Cortona3DSolo.dispatch('app.didAttachDocument', doc);
            if (m_firstFrameDidArrive) {
                beforeFirstFrameRender();
                setTimeout(function () {
                    Cortona3DSolo.dispatch('app.firstFrameDidArrive');
                }, 0);
            }
        }).catch(function (error) {
            Cortona3DSolo.dispatch('app.didFailLoadDocument', error);
            console.error(error);
        });
    },
    firstFrameDidArrive: function (timestamp) {
        m_firstFrameDidArrive = true;
        if (m_didFinishLoadDocument || Module.Stella) {
            beforeFirstFrameRender();
            Cortona3DSolo.dispatch('app.firstFrameDidArrive', timestamp);
        }
    },
    didFailLoadDocument: function (message) {
        Cortona3DSolo.dispatch('app.didFailLoadDocument', deface(message));
    },
    didClickHyperlink: function (urls) {
        Cortona3DSolo.dispatch('app.didClickHyperlink', urls);
    },
    didChangeVisibility: function (shownHandles, hiddenHandles) {
        Cortona3DSolo.dispatch('app.didChangeVisibility', shownHandles, hiddenHandles);
    },
    willStartNavigateInScene: function () {
        m_velocityX = 0;
        m_velocityY = 0;
        m_isPointerDown = false;
        Cortona3DSolo.dispatch('app.willStartNavigateInScene');
    },
    acquireMouseInput: function () {
        var parentDocument;
        try {
            parentDocument = parent.document;
        } catch (e) { }
        if (parentDocument) {
            m_mouseEventTargets = [];
            parentDocument.querySelectorAll('iframe').forEach(function (i) {
                try {
                    var w = i.contentDocument === document ? parent.window : i.contentWindow;
                    w.addEventListener('mousemove', dispatchMouseEvent);
                    w.addEventListener('mouseup', dispatchMouseEvent);
                    m_mouseEventTargets.push(w);
                } catch (e) { }
            });
        }
    },
    unacquireMouseInput: function () {
        if (m_mouseEventTargets) {
            m_mouseEventTargets.forEach(function (i) {
                try {
                    i.removeEventListener('mousemove', dispatchMouseEvent);
                    i.removeEventListener('mouseup', dispatchMouseEvent);
                } catch (e) { }
            });
            m_mouseEventTargets = null;
        }
    },
});

// Tiramisu util
expand(Tiramisu, {
    util: {
        wrapStringArray: base.wrapStringArray,
        wrapSheetArray: base.wrapSheetArray
    },
    initTexture: function (text, width, height, format) {
        if (text === 'navcube') {
            var canvas = createNavigationCubeCanvas(m_navigationCube.localizedText, m_navigationCube.style, navCube.getNavigationCubeSideOrientations()),
                gl = GL.currentContext.GLctx;
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, canvas);
            HEAP32[width >>> 2] = canvas.width;
            HEAP32[height >>> 2] = canvas.height;
            HEAP32[format >>> 2] = 5; // RGBA
        }
    }
});

/**
 * 
 * @private
 * @param {any} doc
 * @returns {Promise}
 * @see external:Promise
 */
function attachInteractivityXML(doc) {
    var src = doc.companionFile;
    var isInteractivityXmlEmissionEnabled = !checkConfigureOptions(app.DISABLE_INTERACTIVITY_XML_EMISSION);
    isInteractivityXmlEmissionEnabled = isInteractivityXmlEmissionEnabled && !!src;
    isInteractivityXmlEmissionEnabled = isInteractivityXmlEmissionEnabled && (doc.type == 'ipc' || doc.type == 'procedure');

    if (isInteractivityXmlEmissionEnabled) {
        var url = app.util.createResourceURL(src) || src;
        if (url) {
            return app.loadCompanionFile(url).then(function (data) {
                if (data && data.type) {
                    var add = {};
                    add[data.type] = {
                        interactivity: data.interactivity
                    };
                    expand(app, add);
                }
            });
        }
    }
    return Promise.resolve();
}

/**
 * @private
 */
function makePanelSnaphot(width, height) {
    var panels = document.getElementById('tiramisu-panel-group');
    var images = panels.querySelectorAll('img');
    var canvases = panels.querySelectorAll('canvas');
    if (images.length > 0 || canvases.length > 0) {
        var panelsCopy = panels.cloneNode(true);
        if (images.length > 0) {
            var imagesCopy = panelsCopy.querySelectorAll('img');
            images.forEach(function (image, index) {
                var canvas = document.createElement('canvas');
                canvas.width = image.naturalWidth;
                canvas.height = image.naturalHeight;
                canvas.getContext('2d').drawImage(image, 0, 0);
                imagesCopy[index].src = canvas.toDataURL();
            });
        }
        if (canvases.length > 0) {
            panelsCopy.querySelectorAll('canvas').forEach(function (canvas, index) {
                var image = new Image();
                image.src = canvases[index].toDataURL();
                canvas.parentNode.replaceChild(image, canvas);
            });
        }
        panels = panelsCopy;
    }
    var style = require('!!raw-loader!@cortona3d/solo-core/src/res/tiramisu.css').default;
    var data =
        '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + '" height="' + height + '"> \
        <foreignObject width="100%" height="100%" style="position: absolute;"> \
        <style>' + style + '</style> \
        ' + new XMLSerializer().serializeToString(panels) + ' \
        </foreignObject></svg>';
    var img = new Image();
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(data);
    return img;
}

/**
 * Attaching some additional `<canvas>` listeners. 
 * 
 * @private
 */
var _t;
var m_isPointerDown;
var m_velocityX = 0,
    m_velocityY = 0;

function attachCanvasListeners() {
    function eventStopper(event) {
        event.stopPropagation();
    }

    Array.prototype.slice.call(document.getElementsByClassName('cortona3dsolo-popover')).forEach(function (popover) {
        popover.addEventListener('contextmenu', function (event) {
            event.preventDefault();
        }, false);
        popover.addEventListener('pointerdown', eventStopper, false);
        popover.addEventListener('pointerup', eventStopper, false);
    });

    function contextmenu(e) {
        if (m_isPressed) return;
        var target = e.target,
            rect = target.getBoundingClientRect(),
            offsetX = e.clientX - rect.left,
            offsetY = e.clientY - rect.top;

        Cortona3DSolo.dispatch('app.didCallContextMenu', offsetX, offsetY, target);
        if (e.preventDefault) e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
    }

    function pressHandler(e) {
        if (e.pointerType === 'mouse') return;
        contextmenu(e);
    }

    function doubleTapHandler(e) {
        var target = e.target,
            rect = target.getBoundingClientRect(),
            offsetX = e.clientX - rect.left,
            offsetY = e.clientY - rect.top,
            obj = app.pickObject(offsetX, offsetY);
        clearTimeout(_t);
        if (!obj && checkConfigureOptions(app.DISABLE_DISCARDABLE_GEOMETRY_DATA)) {
            obj = app.pickObjectChain(offsetX, offsetY);
        }
        if (!Cortona3DSolo.app.navigator.objectFitDisabled) {
            if (obj) {
                if (obj.handle) {
                    app.fitObjectsInView([obj.handle], true);
                } else if (obj.chain) {
                    app.fitChainInView(obj.chain, true);
                } else {
                    app.fitSceneInView(true);    
                }
            } else {
                app.fitSceneInView(true);
            }
        }
        Cortona3DSolo.dispatch('app.didDoubleClick', obj && obj.handle, offsetX, offsetY, e);
        if (e.preventDefault) e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
    }

    var isMSGestureEnabled = livingOnTheEdge();

    Module.canvas.addEventListener('contextmenu', contextmenu);
    Module.canvas.addEventListener('pointerdown', function () {
        if (document.activeElement && document.activeElement.blur) {
            document.activeElement.blur();
        }
        clearTimeout(_t_singleTap);
        m_isPointerDown = true;
        m_velocityX = 0;
        m_velocityY = 0;
    });

    function singleTapHandler(event) {
        if (event.altKey || event.button === 1) { // Alt or Middle button
            var target = event.target || event.srcElement,
                rect = target.getBoundingClientRect(),
                offsetX = event.clientX - rect.left,
                offsetY = event.clientY - rect.top,
                obj = app.pickObject(offsetX, offsetY);

            if ((!obj || !event.ctrlKey) && checkConfigureOptions(app.DISABLE_DISCARDABLE_GEOMETRY_DATA)) {
                obj = app.pickObjectChain(offsetX, offsetY);
                if (obj) {
                    if (event.ctrlKey) { // Ctrl
                        obj = {
                            handle: obj.chain[obj.chain.length - 2]
                        };
                    } else {
                        var x = obj.sceneCoord[0],
                            y = obj.sceneCoord[1],
                            z = obj.sceneCoord[2];
                        clearTimeout(_t);
                        _t = setTimeout(function () {
                            app.setRotationCenterToPoint(x, y, z);
                            app.centerRotationCenterInView(true);
                        }, 100);
                        event.preventDefault();
                        event.stopPropagation();
                        return;
                    }
                }
            }

            if (obj) {
                var handle = obj.handle;
                clearTimeout(_t);
                _t = setTimeout(function () {
                    app.setRotationCenterToObjects(handle);
                    app.centerRotationCenterInView(true);
                }, 100);
                event.preventDefault();
                event.stopPropagation();
            }
        }
    }

    var _t_singleTap;

    Module.canvas.addEventListener('pointerup', function (event) {
        if (!Cortona3DSolo.app.navigator.changeCenterpointDisabled) {
            if (m_isPointerDown) {
                m_isPointerDown = false;
                _t_singleTap = setTimeout(singleTapHandler.bind(null, event), DOUBLE_TAP_TIME);
            }
        }
    }, false);

    var inertiaLastTime = 0;

    function inertia() {
        var nav = Cortona3DSolo.app.navigator,
            now = new Date(),
            dt = now - inertiaLastTime,
            a = nav.inertiaDecelerationFactor * 0.005 * Math.sqrt(m_velocityX * m_velocityX + m_velocityY * m_velocityY),
            ds = a * dt * dt * 0.5,
            dx = (Math.abs(m_velocityX) * dt - ds) * Math.sign(m_velocityX),
            dy = (Math.abs(m_velocityY) * dt - ds) * Math.sign(m_velocityY);
        inertiaLastTime = now;
        m_velocityX = Math.max(0, Math.abs(m_velocityX) - a * dt) * Math.sign(m_velocityX);
        m_velocityY = Math.max(0, Math.abs(m_velocityY) - a * dt) * Math.sign(m_velocityY);
        if (Math.abs(m_velocityX) < 0.001) m_velocityX = 0;
        if (Math.abs(m_velocityY) < 0.001) m_velocityY = 0;
        switch (nav.mouseDragMode) {
            case nav.MOUSE_DRAG_MODE_SPIN:
                nav.spin(-dx / 100, -dy / 100);
                break;
            case nav.MOUSE_DRAG_MODE_PAN:
                nav.pan(dx, dy);
                break;
            case nav.MOUSE_DRAG_MODE_ZOOM:
                nav.zoom(1 + dy / 100);
                break;
        }

        if (m_velocityX || m_velocityY) {
            requestAnimationFrame(inertia);
        }
    }

    var lastTapTime = 0,
        lastTapPoint = {};

    var distance = function (p1, p2) {
        return Math.sqrt((p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y));
    };

    if (isMSGestureEnabled) {
        Module.canvas.addEventListener('dblclick', doubleTapHandler);
        Module.canvas.addEventListener('MSGestureTap', function (e) {
            if (e.detail === (e.MSGESTURE_FLAG_BEGIN + e.MSGESTURE_FLAG_END)) {
                if (!lastTapTime) {
                    lastTapTime = new Date().valueOf();
                    lastTapPoint.x = e.screenX;
                    lastTapPoint.y = e.screenY;
                } else if ((new Date().valueOf() - lastTapTime) <= DOUBLE_TAP_TIME) {
                    lastTapTime = 0;
                    if (distance(lastTapPoint, {
                        x: e.screenX,
                        y: e.screenY
                    }) < 100) { // posThreshold
                        doubleTapHandler(e);
                    }
                } else {
                    lastTapTime = 0;
                }
            }
        });
        Module.canvas.addEventListener('MSGestureHold', function (e) {
            if (e.detail & e.MSGESTURE_FLAG_BEGIN) {
                m_isPressed = true;
            } else if (e.detail & e.MSGESTURE_FLAG_END) {
                setTimeout(function () {
                    m_isPressed = false;
                }, 250);
            }
        });

    } else {
        var mcOptions = {};
        if (navigator.pointerEnabled === false) {
            if (SUPPORT_ONLY_TOUCH) {
                mcOptions.inputClass = Hammer.TouchInput;
            } else if (!SUPPORT_TOUCH) {
                mcOptions.inputClass = Hammer.MouseInput;
            } else {
                mcOptions.inputClass = Hammer.TouchMouseInput;
            }
        }
        var mc = new Hammer.Manager(Module.canvas, mcOptions);
        var press = new Hammer.Press({
            time: PRESS_TIME
        });
        var doubletap = new Hammer.Tap({
            event: 'doubletap',
            taps: 2,
            threshold: 5,
            posThreshold: 100,
            interval: DOUBLE_TAP_TIME
        });
        var swipe = new Hammer.Swipe({
            threshold: 5,
            velocity: 0.3
        });
        doubletap.recognizeWith(press);
        press.requireFailure(doubletap);
        mc.add(press);
        mc.add(doubletap);
        mc.add(swipe);
        mc.set({
            touchAction: 'none'
        });
        mc.on('press', function (e) {
            pressHandler(e.srcEvent);
        });
        mc.on('doubletap', function (e) {
            doubleTapHandler(e.srcEvent);
        });
        mc.on('swipe', function (e) {
            if (Cortona3DSolo.app.navigator.inertiaDisabled) return;
            m_velocityX = e.overallVelocityX;
            m_velocityY = e.overallVelocityY;
            inertiaLastTime = new Date();
            requestAnimationFrame(inertia);
        });
    }
}

/**
 * Adapting to survive in Microsoft's neighborhood. 
 * 
 * @private
 */
function livingOnTheEdge() {
    if (typeof window.MSGesture !== 'function')
        return false;

    var canvas = Module.canvas,
        recognizer = new MSGesture();

    recognizer.target = canvas;

    function gestureHandler(event) {
        microsoftGesture(event.translationX, event.translationY, event.scale, event.rotation, event.detail);
    }

    function microsoftGesture(x, y, scale, rotation, detail) {
        Module._tiramisu_microsoftGesture(x, y, scale, rotation, detail);
    }

    function microsoftPointerUp(pointerId, offsetX, offsetY) {
        return Module._tiramisu_microsoftPointerUp(pointerId, offsetX, offsetY);
    }

    function microsoftPointerDown(pointerId, offsetX, offsetY) {
        return Module._tiramisu_microsoftPointerDown(pointerId, offsetX, offsetY);
    }

    canvas.addEventListener('MSHoldVisual', function (event) {
        event.preventDefault();
    }, false);
    canvas.addEventListener('MSGestureStart', gestureHandler, false);
    canvas.addEventListener('MSGestureEnd', gestureHandler, false);
    canvas.addEventListener('MSGestureChange', gestureHandler, false);
    canvas.addEventListener('MSInertiaStart', gestureHandler, false);
    canvas.addEventListener('MSGestureTap', gestureHandler, false);
    canvas.addEventListener('MSGestureHold', gestureHandler, false);
    canvas.addEventListener('pointerdown', function (event) {
        if (event.pointerType == 'mouse') {
            canvas.setPointerCapture(event.pointerId);
            return;
        }
        if (microsoftPointerDown(event.pointerId, event.offsetX, event.offsetY)) {
            canvas.setPointerCapture(event.pointerId);
            if (!recognizer.target) {
                recognizer.target = canvas;
            }
            recognizer.addPointer(event.pointerId);
        }
    }, false);
    canvas.addEventListener('pointerup', function (event) {
        if (event.pointerType == 'mouse') return;
        event.stopPropagation();
        microsoftPointerUp(event.pointerId, event.offsetX, event.offsetY);
    }, false);
    window.addEventListener('pointerup', function (event) {
        if (event.pointerType == 'mouse') return;
        var box = canvas.getBoundingClientRect(),
            left = box.left + window.pageXOffset - document.body.clientLeft,
            top = box.top + window.pageYOffset - document.body.clientTop;
        microsoftPointerUp(event.pointerId, event.pageX - left, event.pageY - top);
    }, false);

    return true;
}

var appExports = {
    /**
     * Returns Cortona3D Solo version string.
     * 
     * @memberof module:solo.app
     * @returns {string} Version string 
     */
    version: function () {
        var major = (Tiramisu.VERSION >> 24),
            minor = (Tiramisu.VERSION >> 16) & 0xFF,
            build = Tiramisu.VERSION & 0xFFFF,
            buildTime = new Date(Tiramisu.BUILD_TIME * 1000);
        return VERSION + " (core: " + [major, minor, build].join('.') + ")";
    },

    /**
     * Changes the `<canvas>` element size. This function must be called to resize 3D window.
     * 
     * @memberof module:solo.app
     * @param {number} width - pixels
     * @param {number} height - pixels
     * @see {@link module:solo.core.canvas core.canvas}
     */
    resize: function (width, height) {
        if (!m_doc) return;
        Module._tiramisu_resize(width, height);
    },

    /**
     * Returns name of 3D object by its handle.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object 
     * @returns {string} Name of 3D object 
     */
    getObjectName: function (handle) {
        return Module.ccall('tiramisu_getObjectName', 'string', ['number'], arguments);
    },

    /**
     * Returns type of 3D object by its handle.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object 
     * @returns {string} Type of 3D object 
     * @since 1.4.0
     */
    getObjectTypeName: function (handle) {
        return Module.ccall('tiramisu_getObjectTypeName', 'string', ['number'], arguments);
    },

    /**
     * Returns handle of 3D object by its name.
     * 
     * @memberof module:solo.app
     * @param {string} name - Name of 3D object
     * @returns {Handle} Handle of 3D object
     */
    getObjectWithName: function (name) {
        return Module.ccall('tiramisu_getObjectWithName', 'number', ['string'], arguments);
    },

    /**
     * Checks whether a 3D object is ignored by the picker. 
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @returns {boolean}
     * @see {@link module:solo.app.setObjectIgnorableByPicker app.setObjectIgnorableByPicker()}
     */
    isObjectIgnorableByPicker: function (handle) {
        return Module._tiramisu_isObjectIgnorableByPicker(handle) !== 0;
    },

    /**
     * Sets whether a 3D object is ignored by picker.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @param {boolean} ignorable
     * @see {@link module:solo.app.isObjectIgnorableByPicker app.isObjectIgnorableByPicker()}
     */
    setObjectIgnorableByPicker: function (handle, ignorable) {
        Module._tiramisu_setObjectIgnorableByPicker(handle, ignorable);
    },

    /**
     * Sends a ray from the picked point in the 3D window and returns 3D object that was hit by the ray.
     * 
     * @memberof module:solo.app
     * @param {number} x - The X coordinate relative to the element `<canvas>`
     * @param {number} y - The Y coordinate relative to the element `<canvas>`
     * @param {boolean} [needsTopLevelParent] - 
     * - true - returns the topmost element in a picked chain of 3D objects
     * - false - returns a 3D object that was hit by the ray
     * @returns {PickedObjectInfo|null} Information about the picked 3D object or null if there are no picked 3D objects
     */
    pickObject: function (x, y, needsTopLevelParent) {
        var mode = typeof needsTopLevelParent == 'undefined' ? 0 : needsTopLevelParent ? 512 : 256;
        node = Module._tiramisu_pickObject(x, y, mode);
        return node ? {
            handle: node,
            name: Module.ccall('tiramisu_getObjectName', 'string', ['number'], [node])
        } : null;
    },

    /**
     * Sends a ray from the picked point in the 3D window and returns information about picked point and a chain of 3D objects.
     * The method works with generic VRML file.
     * 
     * > #### __NOTE__
     * >
     * > Required use of the {@link module:solo.app DISABLE_DISCARDABLE_GEOMETRY_DATA} flag when initializing the library.
     * >```
     * >    Cortona3DSolo.use('core', { 
     * >        features: Cortona3DSolo.app.DISABLE_DISCARDABLE_GEOMETRY_DATA
     * >    });
     * >```
     * 
     * @memberof module:solo.app
     * @param {number} x - The X coordinate relative to the element `<canvas>`
     * @param {number} y - The Y coordinate relative to the element `<canvas>`
     * @returns {PickedObjectChain|null} The object with result structure or null if there are no picked 3D objects
     * @see {@link module:solo.use use()}
     * @since 1.4.0
     */
    pickObjectChain: function (x, y, options) {
        var result = Module._tiramisu_pickObjectChain(x, y, options || 0);
        if (!result) return null;
        var obj = unmarshalPickResult(result);
        Module._free(result);
        return obj;
    },

    /**
     * Sends a ray from the origin point along the direction vector and returns information about picked point and a chain of 3D objects.
     * The method works with generic VRML file.
     * 
     * > #### __NOTE__
     * >
     * > Required use of the {@link module:solo.app DISABLE_DISCARDABLE_GEOMETRY_DATA} flag when initializing the library.
     * >```
     * >    Cortona3DSolo.use('core', { 
     * >        features: Cortona3DSolo.app.DISABLE_DISCARDABLE_GEOMETRY_DATA
     * >    });
     * >```
     * 
    * @memberof module:solo.app
    * @param {Ray} ray - Structure with information about the ray
    * @returns {PickedObjectChain|null} The object with result structure or null if there are no picked 3D objects
    * @see {@link module:solo.use use()}
    * @since 2.1.0
    */
    pickObjectChainWithRay: function (ray, options) {
        var sp = stackSave(),
            rayData = stackAlloc(24);
        assignVec3f(rayData, ray.origin);
        assignVec3f(rayData + 12, ray.direction);
        var result = Module._tiramisu_pickObjectChainWithRay(rayData, options || 0);
        stackRestore(sp);
        if (!result) return null;
        var objs = unmarshalPickResult(result);
        Module._free(result);
        return objs;
    },

    /**
     * Sends a ray from the picked point in the 3D window and returns information about chains for all 3D objects that the ray intersects.
     * The results are ordered by distance.
     * 
     * > #### __NOTE__
     * >
     * > Required use of the {@link module:solo.app DISABLE_DISCARDABLE_GEOMETRY_DATA} flag when initializing the library.
     * >```
     * >    Cortona3DSolo.use('core', { 
     * >        features: Cortona3DSolo.app.DISABLE_DISCARDABLE_GEOMETRY_DATA
     * >    });
     * >```
     * 
     * @memberof module:solo.app
     * @param {number} x - The X coordinate relative to the element `<canvas>`
     * @param {number} y - The Y coordinate relative to the element `<canvas>`
     * @returns {PickedObjectChain[]|null} Array of results with chains or null if there are no picked 3D objects
     * @see {@link module:solo.use use()}
     * @since 2.1.0
     */
    pickAllObjectChains: function (x, y, options) {
        var results = Module._tiramisu_pickAllObjectChains(x, y, options || 0);
        if (!results) return null;
        var objs = unmarshalPickResults(results);
        Module._free(results);
        return objs;
    },

    /**
     * Sends a ray from the origin point along the direction vector and returns information about chains for all 3D objects that the ray intersects.
     * The results are ordered by distance.
     * 
     * > #### __NOTE__
     * >
     * > Required use of the {@link module:solo.app DISABLE_DISCARDABLE_GEOMETRY_DATA} flag when initializing the library.
     * >```
     * >    Cortona3DSolo.use('core', { 
     * >        features: Cortona3DSolo.app.DISABLE_DISCARDABLE_GEOMETRY_DATA
     * >    });
     * >```
     * 
     * @memberof module:solo.app
     * @param {Ray} ray - Structure with information about the ray
     * @returns {PickedObjectChain[]|null} Array of results with chains or null if there are no picked 3D objects
     * @see {@link module:solo.use use()}
     * @since 2.1.0
     */
    pickAllObjectChainsWithRay: function (ray, options) {
        var sp = stackSave(),
            rayData = stackAlloc(24);
        assignVec3f(rayData, ray.origin);
        assignVec3f(rayData + 12, ray.direction);
        var results = Module._tiramisu_pickAllObjectChainsWithRay(rayData, options || 0);
        stackRestore(sp);
        if (!results) return null;
        var objs = unmarshalPickResults(results);
        Module._free(results);
        return objs;
    },

    /**
     * Returns the transparency threshold used by picker.
     * 
     * @memberof module:solo.app
     * @returns {number} The transparency threshold
     * @deprecated since version 1.5.0, use {@link module:solo.app.pickerTransparencyThreshold app.pickerTransparencyThreshold} instead
     */
    getPickerTransparencyThreshold: function () {
        var value = Module._tiramisu_getPickerTransparencyThreshold();
        if (value < 0) value = -1;
        return (value >= 0 && value <= MIN_PICKER_TRANSPARENCY_THRESHOLD) ? 0 : value;
    },

    /**
     * Sets transparency threshold used by picker.
     * 
     * @memberof module:solo.app
     * @param {number} threshold - [0..1]
     * @deprecated since version 1.5.0, use {@link module:solo.app.pickerTransparencyThreshold app.pickerTransparencyThreshold} instead
     */
    setPickerTransparencyThreshold: function (threshold) {
        return Module._tiramisu_setPickerTransparencyThreshold(threshold || MIN_PICKER_TRANSPARENCY_THRESHOLD);
    },

    /**
     * Adds 3D objects to selected objects.
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {AnimatedMode} animated
     * @fires "app.didChangeSelectedObjects"
     */
    addSelectedObjects: function (handles, animated) {
        withObjectHandles(handles, function (objects, count) { return Module._tiramisu_addSelectedObjects(objects, count, animated); });
        Cortona3DSolo.dispatch('app.didChangeSelectedObjects');
    },

    /**
     * Sets 3D objects to selected state.
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {AnimatedMode} animated
     * @fires "app.didChangeSelectedObjects"
     */
    setSelectedObjects: function (handles, animated) {
        withObjectHandles(handles, function (objects, count) { return Module._tiramisu_setSelectedObjects(objects, count, animated); });
        Cortona3DSolo.dispatch('app.didChangeSelectedObjects');
    },

    /**
     * Removes 3D objects from selected objects.
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {AnimatedMode} animated
     * @fires "app.didChangeSelectedObjects"
     * @since 2.0.0
     */
    removeSelectedObjects: function (handles, animated) {
        withObjectHandles(handles, function (objects, count) { return Module._tiramisu_removeSelectedObjects(objects, count, animated); });
        Cortona3DSolo.dispatch('app.didChangeSelectedObjects');
    },

    /**
     * Returns an array of selected 3D objects.
     * 
     * @memberof module:solo.app
     * @returns {Handle[]} An array of 3D object handles
     */
    getSelectedObjects: function () {
        var handles = Module._tiramisu_getSelectedObjects(),
            objects = unmarshalObjectArray(handles);
        Module._free(handles);
        return objects;
    },

    /**
     * Adds 3D objects to hovered objects.
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {AnimatedMode} animated
     * @fires "app.didChangeHoveredObjects"
     * @since 2.0.0
     */
    addHoveredObjects: function (handles, animated) {
        withObjectHandles(handles, function (objects, count) { return Module._tiramisu_addHoveredObjects(objects, count, animated); });
        Cortona3DSolo.dispatch('app.didChangeHoveredObjects');
    },

    /**
     * Sets 3D objects to hovered state.
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {AnimatedMode} animated
     * @fires "app.didChangeHoveredObjects"
     * @since 2.0.0
     */
    setHoveredObjects: function (handles, animated) {
        withObjectHandles(handles, function (objects, count) { return Module._tiramisu_setHoveredObjects(objects, count, animated); });
        Cortona3DSolo.dispatch('app.didChangeHoveredObjects');
    },

    /**
     * Removes 3D objects from hovered objects.
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {AnimatedMode} animated
     * @fires "app.didChangeHoveredObjects"
     * @since 2.0.0
     */
    removeHoveredObjects: function (handles, animated) {
        withObjectHandles(handles, function (objects, count) { return Module._tiramisu_removeHoveredObjects(objects, count, animated); });
        Cortona3DSolo.dispatch('app.didChangeHoveredObjects');
    },

    /**
     * Returns an array of hovered 3D objects.
     * 
     * @memberof module:solo.app
     * @returns {Handle[]} An array of 3D object handles
     * @since 2.0.0
     */
    getHoveredObjects: function () {
        var handles = Module._tiramisu_getHoveredObjects(),
            objects = unmarshalObjectArray(handles);
        Module._free(handles);
        return objects;
    },

    /**
     * Sets the default background color in the 3D scene.
     * An array of color defines the gradient fill. 
     * 
     * @memberof module:solo.app
     * @param {HexColorString|HexColorString[]} colors - A string representing the color or an array of colors
     */
    setDefaultBackgroundColors: function (colors) {
        var count = 0,
            colorArray = 0,
            sp = stackSave();
        m_defaultBackgroundColors = [];
        if (colors) {
            if (typeof colors === 'string') {
                colors = [colors];
            }
            m_defaultBackgroundColors = colors.map(function (c) {
                return millicolor(c).toString();
            });
            count = colors.length;
            colorArray = stackAlloc(count * 4);
            for (var i = 0, p = colorArray >> 2; i < count; ++i, ++p) {
                HEAP32[p] = millicolor(colors[i]).toValue();
            }
        }
        Module._tiramisu_setDefaultBackgroundColors(colorArray, count);
        stackRestore(sp);
    },

    /**
     * Gets the default background color in the 3D scene, 
     * previously set using {@link module:solo.app.setDefaultBackgroundColors app.setDefaultBackgroundColors()}.
     * 
     * @memberof module:solo.app
     * @returns {HexColorString[]} Ann array of colors
     * @since 2.3.2
     * @see {@link module:solo.app.setDefaultBackgroundColors app.setDefaultBackgroundColors()}
     */
    getDefaultBackgroundColors: function () {
        return m_defaultBackgroundColors;
    },

    /**
     * Sets the mouse navigation mode.
     * 
     * @memberof module:solo.app
     * @param {MouseDragMode} mode - Mouse drag mode 
     * @deprecated since version 2.1.4, use {@link module:solo.app.navigator app.navigator} instead
     */
    setMouseDragMode: function (mode) {
        Module._tiramisu_setMouseDragMode(mode);
    },

    /**
     * Sets property for the 3D object.
     * Optional arguments `v0`, `v1`, `v2` and `v3` define the necessary parameters depending on the property type:
     * 
     * - app.PROPERTY_DIFFUSE_COLOR    = 0, `v0` = r, `v1` = g, `v2` = b 
     * - app.PROPERTY_EMISSIVE_COLOR   = 1, `v0` = r, `v1` = g, `v2` = b
     * - app.PROPERTY_TRANSPARENCY     = 2, `v0` = transparency 
     * - app.PROPERTY_VISIBILITY       = 3, `v0` = hidden
     * - app.PROPERTY_TRANSLATION      = 4, `v0` = x, `v1` = y, `v2` = z
     * - app.PROPERTY_ROTATION         = 5, `v0` = x, `v1` = y, `v2` = z, `v3` = angle
     * - app.PROPERTY_SCALE            = 6, `v0` = x, `v1` = y, `v2` = z
     * - app.PROPERTY_CLIP_PROTECTED   = 7, `v0` = protected
     * 
     * where,
     * - r, g, b - number [0 ... 1]
     * - transparency - number [-1 ... 1]
     * - hidden - boolean
     * - x, y, z - number
     * - angle - number in radians
     * 
     * > #### __NOTE__
     * >
     * > The transparency level is set by a number from -1 to 1, 
     * > where 0 is the current transparency level of the object's material in the scene, 
     * > -1 is the opaque material, 
     * > and 1 is the transparent material.
     *
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of the 3D object
     * @param {ObjectProperty} property - Property type code
     * @param {AnimatedMode} animated
     * @param {number} v0 - Parameter depending on the property type
     * @param {number} [v1] - Parameter depending on the property type
     * @param {number} [v2] - Parameter depending on the property type
     * @param {number} [v3] - Parameter depending on the property type
     * @returns {boolean} Return true if changed
     * @see {@link module:solo.app.restoreObjectProperty app.restoreObjectProperty()}
     * @see {@link module:solo.app.getObjectPropertyf app.getObjectPropertyf()}
     */
    setObjectPropertyf: function (handle, property, animated, v0, v1, v2, v3) {
        if (property === app.PROPERTY_VISIBILITY && m_doc.type === 'generic') {
            var visible = Module._tiramisu_isObjectVisibile(handle) !== 0,
                render = !v0;
            if (!(handle in m_hiddenObjects)) {
                m_hiddenObjects[handle] = visible;
            }
            if (m_hiddenObjects[handle] === render) {
                delete m_hiddenObjects[handle];
            }
            if (visible !== render) {
                Module._tiramisu_setObjectVisibility(handle, render);
                return true;
            }
            return false;
        }
        return Module._tiramisu_setObjectPropertyf(handle, property, animated, v0, v1, v2, v3) !== 0;
    },

    /**
     * Gets property for the 3D object.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of the 3D object
     * @param {ObjectProperty} property - Property code
     * @returns {number|number[]|null} Value of the requested property
     * @see {@link module:solo.app.setObjectPropertyf app.setObjectPropertyf()}
     * @since 1.6.3
     */
    getObjectPropertyf: function (handle, property) {
        var value;
        if (property === app.PROPERTY_VISIBILITY && m_doc.type === 'generic') {
            value = Module._tiramisu_isObjectVisibile(handle) === 0;
        } else {
            var sp = stackSave(),
                buffer = stackAlloc(4 * 4),
                count = Module._tiramisu_getObjectPropertyf(handle, property, buffer),
                value = unmarshalFloatArray(buffer, count);
            stackRestore(sp);
            if (property === app.PROPERTY_VISIBILITY) {
                value = !!value;
            }
        }
        return value;
    },

    /**
     * Restores property value for the 3D object.
     * Pass handle = 0 to restore property of all dirty objects.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @param {ObjectProperty} property - Property
     * @param {AnimatedMode} animated
     * @returns {boolean} Returns true if changed
     * @see {@link module:solo.app.setObjectPropertyf app.setObjectPropertyf()}
     */
    restoreObjectProperty: function (handle, property, animated) {
        if (property === app.PROPERTY_VISIBILITY && m_doc.type === 'generic') {
            if (handle) {
                if (handle in m_hiddenObjects) {
                    var visible = Module._tiramisu_isObjectVisibile(handle) !== 0,
                        render = m_hiddenObjects[handle];
                    delete m_hiddenObjects[handle];
                    if (visible !== render) {
                        Module._tiramisu_setObjectVisibility(handle, render);
                        return true;
                    }
                }
                return false;
            }
            for (var h in m_hiddenObjects) {
                Module._tiramisu_setObjectVisibility(h, m_hiddenObjects[h]);
            }
            m_hiddenObjects = {};
        }
        return Module._tiramisu_restoreObjectProperty(handle || 0, property, animated) !== 0;
    },

    /**
     * Returns array of 3D objects with dirty property. 
     * 
     * @memberof module:solo.app
     * @param {ObjectProperty} property - Property
     * @returns {Handle[]} Array of 3D objects
     * @see {@link module:solo.app.setObjectPropertyf app.setObjectPropertyf()}
     */
    getObjectsWithDirtyProperty: function (prop) {
        if (prop === app.PROPERTY_VISIBILITY) {
            if (m_doc.type === 'generic') {
                var res = [];
                for (var h in m_hiddenObjects) {
                    res.push(h);
                }
                return res;
            }
        }
        var handles = Module._tiramisu_getObjectsWithDirtyProperty(prop),
            objects = unmarshalObjectArray(handles);
        Module._free(handles);
        return objects;
    },

    /**
     * Gets the 3D object highlight parameters.
     * 
     * @memberof module:solo.app
     * @param {ObjectHighlightEnum} type 
     * @returns {ObjectHighlightParams|null}
     * @since 2.0.0
     */
    getObjectHighlightParams: function (type) {
        var p = Module._tiramisu_getObjectHighlightParams(type) >>> 2;
        return p ? {
            diffuseColor: millicolor([HEAPF32[p], HEAPF32[p + 1], HEAPF32[p + 2]]).toString(),
            diffuseBrightnessDelta: HEAPF32[p + 3],
            emissiveColor: millicolor([HEAPF32[p + 4], HEAPF32[p + 5], HEAPF32[p + 6]]).toString(),
            emissiveBrightnessDelta: HEAPF32[p + 7],
            transparency: HEAPF32[p + 8]
        } : null;
    },

    /**
     * Sets the 3D object highlight parameters.
     * 
     * @memberof module:solo.app
     * @param {ObjectHighlightEnum} type 
     * @param {ObjectHighlightParams|null} params 
     * @since 2.0.0
     */
    setObjectHighlightParams: function (type, params) {
        if (!params) {
            Module._tiramisu_setObjectHighlightParams(type, 0);
            return;
        }

        var sp = stackSave(),
            mem = stackAlloc(36),
            p = mem >>> 2;

        function assign(offset, color, brightness) {
            if (color && color.length > 2) {
                HEAPF32[p + offset] = color[0];
                HEAPF32[p + offset + 1] = color[1];
                HEAPF32[p + offset + 2] = color[2];
                HEAPF32[p + offset + 3] = typeof (brightness) !== 'undefined' ? brightness : 0;
            } else {
                HEAPF32[p + offset] = 0;
                HEAPF32[p + offset + 1] = 0;
                HEAPF32[p + offset + 2] = 0;
                HEAPF32[p + offset + 3] = typeof (brightness) !== 'undefined' ? brightness : 1;
            }
        }

        assign(0, millicolor(params.diffuseColor).toArray(), params.diffuseBrightnessDelta);
        assign(4, millicolor(params.emissiveColor).toArray(), params.emissiveBrightnessDelta);
        HEAPF32[p + 8] = typeof(params.transparency) !== 'undefined' ? params.transparency : 0;
        Module._tiramisu_setObjectHighlightParams(type, mem);
        stackRestore(sp);
    },

    /**
     * Checks if the center of rotation is visible.
     * 
     * @memberof module:solo.app
     * @returns {boolean} 
     * @deprecated since version 1.8.1, use {@link module:solo.app.rotationCenterVisible app.rotationCenterVisible} instead
     */
    isRotationCenterVisible: function () {
        return _tiramisu_isRotationCenterVisible() !== 0;
    },

    /**
     * Toggles the visibility of the center of rotation.
     * 
     * @memberof module:solo.app
     * @param {boolean} visible - Flag
     * @deprecated since version 1.8.1, use {@link module:solo.app.rotationCenterVisible app.rotationCenterVisible} instead
     */
    setRotationCenterVisibility: function (visible) {
        Module._tiramisu_setRotationCenterVisibility(visible);
    },

    /**
     * Restores the default camera position.
     * 
     * @memberof module:solo.app
     * @param {AnimatedMode} [animated]
     */
    setDefaultView: function (animated) {
        Module._tiramisu_setDefaultView(animated);
    },

    /**
     * Aligns the camera horizon.
     * 
     * @memberof module:solo.app
     * @param {AnimatedMode} [animated]
     * @since 1.6.2
     */
    alignHorizon: function (animated) {
        Module._tiramisu_alignHorizon(animated);
    },

    /**
     * Sets standard view by name.
     * 
     * @memberof module:solo.app
     * @param {StandardViewName} viewName Name of standard view
     * @param {AnimatedMode} animated
     * @param {number} [factor=0.95]
     * @see {@link module:solo.app.defaultFitFactorScene app.defaultFitFactorScene}
     */
    jumpToStandardView: function (viewName, animated, factor) {
        Module.ccall('tiramisu_jumpToStandardView', 'null', ['string', 'number', 'number'], [viewName, animated, factor || m_fitFactorScene]);
    },

    /**
     * Fits to visible part of the 3D scene.
     * 
     * @memberof module:solo.app
     * @param {AnimatedMode} animated
     * @param {number} [factor=0.95]
     * @see {@link module:solo.app.defaultFitFactorScene app.defaultFitFactorScene}
     */
    fitSceneInView: function (animated, factor) {
        Module._tiramisu_fitObjectsInView(0, -1, 0, animated, factor || m_fitFactorScene);
    },

    /**
     * Fits to visible part of the 3D scene with the camera orientation.
     * 
     * @memberof module:solo.app
     * @param {number[]|0|string} cameraOrientation - Orientation of the camera as an array of 4 floating-point numbers [x, y, z, angle] or name of the predefined camera view:
     * - "front"
     * - "back"
     * - "left"
     * - "right"
     * - "top"
     * - "bottom"
     * - "isometric"
     * @param {AnimatedMode} animated
     * @param {number} [factor=0.95]
     * @see {@link module:solo.app.defaultFitFactorScene app.defaultFitFactorScene}
     */
    fitSceneInViewWithCameraOrientation: function (cameraOrientation, animated, factor) {
        var sp = stackSave();
        Module._tiramisu_fitObjectsInView(0, -1, toRotation(getCameraOrientation(cameraOrientation)), animated, factor || m_fitFactorScene);
        stackRestore(sp);
    },

    /**
     * Fits to selected 3D objects in the 3D scene.
     * 
     * @memberof module:solo.app
     * @param {AnimatedMode} animated
     * @param {number} [factor=0.5]
     * @see {@link module:solo.app.defaultFitFactorObject app.defaultFitFactorObject}
     */
    fitSelectedObjectsInView: function (animated, factor) {
        Module._tiramisu_fitObjectsInView(0, -2, 0, animated, factor || m_fitFactorObject);
    },

    /**
     * Fits to selected 3D objects in the 3D scene with the camera orientation.
     * 
     * @memberof module:solo.app
     * @param {number[]|0|string} cameraOrientation - Orientation of the camera as an array of 4 floating-point numbers [x, y, z, angle] or name of the predefined camera view:
     * - "front"
     * - "back"
     * - "left"
     * - "right"
     * - "top"
     * - "bottom"
     * - "isometric"
     * @param {AnimatedMode} animated
     * @param {number} [factor=0.5]
     * @see {@link module:solo.app.defaultFitFactorObject app.defaultFitFactorObject}
     */
    fitSelectedObjectsInViewWithCameraOrientation: function (cameraOrientation, animated, factor) {
        var sp = stackSave();
        Module._tiramisu_fitObjectsInView(0, -2, toRotation(getCameraOrientation(cameraOrientation)), animated, factor || m_fitFactorObject);
        stackRestore(sp);
    },

    /**
     * Fits to multiple 3D objects in the 3D scene .
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {AnimatedMode} animated
     * @param {number} [factor=0.5]
     * @see {@link module:solo.app.defaultFitFactorObject app.defaultFitFactorObject}
     */
    fitObjectsInView: function (handles, animated, factor) {
        withObjectHandles(handles, function (objects, count) { return Module._tiramisu_fitObjectsInView(objects, count, 0, animated, factor || m_fitFactorObject); });
    },

    /**
     * Fits to multiple 3D objects in the 3D scene with the camera orientation.
     * 
     * @memberof module:solo.app
     * @param {number[]|0|string} cameraOrientation - Orientation of the camera as an array of 4 floating-point numbers [x, y, z, angle] or name of the predefined camera view:
     * - "front"
     * - "back"
     * - "left"
     * - "right"
     * - "top"
     * - "bottom"
     * - "isometric"
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {AnimatedMode} animated
     * @param {number} [factor=0.5]
     * @see {@link module:solo.app.defaultFitFactorObject app.defaultFitFactorObject}
     */
    fitObjectsInViewWithCameraOrientation: function (handles, cameraOrientation, animated, factor) {
        withObjectHandles(handles, function (objects, count) {
            return Module._tiramisu_fitObjectsInView(objects, count, toRotation(getCameraOrientation(cameraOrientation)), animated, factor || m_fitFactorObject);
        });
    },

    /**
     * Fits to 3D objects, which are represented by a chain of parent nodes.
     * 
     * @memberof module:solo.app
     * @param {Handle[]} chain - An array of picked 3D objects. Starting with the root element of the scene.
     * @param {AnimatedMode} animated
     * @param {number} [factor=0.5]
     * @see {@link module:solo.app.defaultFitFactorObject app.defaultFitFactorObject}
     */
    fitChainInView: function (chain, animated, factor) {
        withObjectHandles(chain, function (objects, count) { return Module._tiramisu_fitChainInView(objects, count, 0, animated, factor || m_fitFactorObject); });
    },

    /**
     * Fits to 3D objects, which are represented by a chain of parent nodes with the camera orientation.
     * 
     * @memberof module:solo.app
     * @param {number[]|0|string} cameraOrientation - Orientation of the camera as an array of 4 floating-point numbers [x, y, z, angle] or name of the predefined camera view:
     * - "front"
     * - "back"
     * - "left"
     * - "right"
     * - "top"
     * - "bottom"
     * - "isometric"
     * @param {Handle[]} chain - An array of picked 3D objects. Starting with the root element of the scene.
     * @param {AnimatedMode} animated
     * @param {number} [factor=0.5]
     * @see {@link module:solo.app.defaultFitFactorObject app.defaultFitFactorObject}
     */
    fitChainInViewWithCameraOrientation: function (chain, cameraOrientation, animated, factor) {
        withObjectHandles(chain, function (objects, count) {
            return Module._tiramisu_fitChainInView(objects, count, toRotation(getCameraOrientation(cameraOrientation)), animated, factor || m_fitFactorObject);
        });
    },


    /**
     * Sets the center of rotation in the center of the bounding box of visible part of the 3D scene.
     * 
     * @memberof module:solo.app
     * @param {boolean} [preservePositionInCamera=false]
     */
    setRotationCenterToScene: function (preservePositionInCamera) {
        Module._tiramisu_setRotationCenterToObjects(0, -1, preservePositionInCamera);
    },

    /**
     * Sets the center of rotation in the center of the bounding box of selected 3D objects.
     * 
     * @memberof module:solo.app
     * @param {boolean} [preservePositionInCamera=false]
     */
    setRotationCenterToSelectedObjects: function (preservePositionInCamera) {
        Module._tiramisu_setRotationCenterToObjects(0, -2, preservePositionInCamera);
    },

    /**
     * Sets the center of rotation in the center of the bounding box of 3D objects assigned in the array.
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {boolean} [centerRotationCenter=false]
     * @param {boolean} [preservePositionInCamera=false]
     */
    setRotationCenterToObjects: function (handles, centerRotationCenter, preservePositionInCamera) {
        withObjectHandles(handles, function (objects, count) { return Module._tiramisu_setRotationCenterToObjects(objects, count, preservePositionInCamera); });
        if (centerRotationCenter) {
            Module._tiramisu_centerRotationCenterInView(centerRotationCenter);
        }
    },

    /**
     * Sets the center of rotation in the point of the screen.
     * 
     * @memberof module:solo.app
     * @param {number} x
     * @param {number} y
     * @param {number} z
     * @since 1.8.3
     */
    setRotationCenterToPoint: function (x, y, z) {
        Module._tiramisu_setRotationCenterToPoint(x, y, z);
    },

    /**
     * Sets the center of rotation in the center of the screen.
     * 
     * @memberof module:solo.app
     * @param {AnimatedMode} animated
     */
    centerRotationCenterInView: function (animated) {
        Module._tiramisu_centerRotationCenterInView(animated);
    },

    /**
     * Sets the center of rotation to default position.
     * 
     * @memberof module:solo.app
     */
    resetRotationCenter: function () {
        Module._tiramisu_resetRotationCenter();
    },

    /**
     * Gets a description of the loaded interactive model.
     * Returns an object depending on the type of interactive model.
     * 
     * @memberof module:solo.app
     * @returns {DocumentInfo}
     * @deprecated since version 1.5.0, use {@link module:solo.app.modelInfo app.modelInfo} instead
     */
    getDocumentInfo: function () {
        return m_doc && expand({}, m_doc);
    },

    /**
     * Returns options of the interactive model from the companion file *.interactivity.xml* in the form of an object with key/value pairs.
     * 
     * @memberof module:solo.app
     * @returns {KeyValuePairs}
     * @since 1.4.0
     */
    getOptions: function () {
        var pairs = Module._tiramisu_getOptions(),
            dict = {},
            name;
        if (pairs) {
            for (var p = pairs >>> 2; (name = HEAPU32[p]); p += 2)
                dict[UTF8ToString(name)] = UTF8ToString(HEAPU32[p + 1]);
            Module._free(pairs);
        }
        return dict;
    },

    /**
     * Returns the value of the option of the interactive model.
     * 
     * @memberof module:solo.app
     * @param {string} name - The name of the option
     * @returns {string} The value of the option
     * @since 1.4.0
     */
    getOption: function (name) {
        var value = Module.ccall('tiramisu_getOption', 'number', ['string'], [name]);
        if (!value)
            return;
        return UTF8ToString(value);
    },

    /**
     * Sets the name of the 3D object.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - A handle of 3D object 
     * @param {string} name - A name of 3D object
     * @since 1.4.0
     */
    setObjectName: function (handle, name) {
        Module.ccall('tiramisu_setObjectName', 'null', ['number', 'string'], arguments);
    },

    /**
     * Returns the current color of the hovered 3D object in the interactive model.
     * 
     * @memberof module:solo.app
     * @returns {HexColorString}
     * @since 1.4.0
     * @deprecated since version 1.5.0, use {@link module:solo.app.hoverColor app.hoverColor} instead
     */
    getHoverColor: function () {
        return millicolor(Module._tiramisu_getHoverColor()).toString()
    },

    /**
     * Sets the color of the hovered 3D object in the interactive model.
     * 
     * @memberof module:solo.app
     * @param {HexColorString}
     * @since 1.4.0
     * @deprecated since version 1.5.0, use {@link module:solo.app.hoverColor app.hoverColor} instead
     */
    setHoverColor: function (color) {
        return Module._tiramisu_setHoverColor(millicolor(color).toValue());
    },

    /**
     * Returns the current color of the selected 3D object in the interactive model.
     * 
     * @memberof module:solo.app
     * @returns {HexColorString}
     * @since 1.4.0
     * @deprecated since version 1.5.0, use {@link module:solo.app.selectionColor app.selectionColor} instead
     */
    getSelectionColor: function () {
        return millicolor(Module._tiramisu_getSelectionColor()).toString();
    },

    /**
     * Sets the color of the selected 3D object in the interactive model.
     * 
     * @memberof module:solo.app
     * @param {HexColorString}
     * @since 1.4.0
     * @deprecated since version 1.5.0, use {@link module:solo.app.selectionColor app.selectionColor} instead
     */
    setSelectionColor: function (color) {
        return Module._tiramisu_setSelectionColor(millicolor(color).toValue());
    },

    /**
     * Gets list of the viewpoints in the VRML scene.
     * 
     * @memberof module:solo.app
     * @returns {ViewpointInfo[]} An array of viewpoints
     * @since 1.4.0
     */
    getViewpoints: function () {
        var bulk = Module._tiramisu_getViewpoints(),
            viewpoints = [],
            handle;
        if (bulk) {
            for (var p = bulk >>> 2; (handle = HEAP32[p]); p += 3) {
                viewpoints.push({
                    handle: handle,
                    name: UTF8ToString(HEAPU32[p + 1]),
                    description: UTF8ToString(HEAPU32[p + 2])
                });
            }
            Module._free(bulk);
        }
        return viewpoints;
    },

    /**
     * Returns active viewpoint.
     * 
     * @memberof module:solo.app
     * @returns {Handle} A handle of the 3D object "viewpoint"
     * @since 1.4.0
     * @deprecated since version 1.5.0, use {@link module:solo.app.activeViewpoint app.activeViewpoint} instead
     */
    getActiveViewpoint: function () {
        return Module._tiramisu_getActiveViewpoint();
    },

    /**
     * Sets active viewpoint.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - A handle of the 3D object "viewpoint"
     * @since 1.4.0
     * @deprecated since version 1.5.0, use {@link module:solo.app.activeViewpoint app.activeViewpoint} instead
     */
    setActiveViewpoint: function (handle) {
        Module._tiramisu_setActiveViewpoint(handle);
    },

    /**
     * Adds new objects in the 3D scene.
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {Handle} [parentHandle] - A handle of the parent 3D object
     * @since 1.4.0
     */
    addObjects: function (handles, parentHandle) {
        var handlesArray = util.isUndefined(handles) ? [] : (Array.isArray(handles) ? handles : [handles]);
        handlesArray.forEach(function (handle) {
            Module._tiramisu_addObject(handle, parentHandle);
        });
    },

    /**
     * Removes objects from the 3D scene.
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {Handle} [parentHandle] - A handle of the parent 3D object
     * @since 1.4.0
     */
    removeObjects: function (handles, parentHandle) {
        var handlesArray = util.isUndefined(handles) ? [] : (Array.isArray(handles) ? handles : [handles]);
        handlesArray.forEach(function (handle) {
            Module._tiramisu_removeObject(handle, parentHandle);
        });
    },

    /**
     * Remove all objects from the 3D scene.
     * 
     * @memberof module:solo.app
     * @param {Handle} [parentHandle] - Parent handle
     * @since 1.4.0
     */
    removeAllObjects: function (parentHandle) {
        Module._tiramisu_removeAllObjects(parentHandle);
    },

    /**
     * Gets child objects for the parent object.
     * 
     * @memberof module:solo.app
     * @param {Handle} [parentHandle] - Parent handle
     * @returns {Handle[]} An array of 3D object handles
     * @since 1.5.0
     */
    getChildObjects: function (parentHandle) {
        var handles = Module._tiramisu_getChildObjects(parentHandle),
            objects = unmarshalObjectArray(handles);
        Module._free(handles);
        return objects;
    },

    /**
     * Sets child objects for the parent object.
     * 
     * @memberof module:solo.app
     * @param {Handle[]} children - An array of 3D object handles
     * @param {Handle} [parentHandle] - Parent handle
     * @returns {boolean}
     * @since 1.5.0
     */
    setChildObjects: function (children, parentHandle) {
        var count = 0,
            result,
            sp = stackSave();
        if (children) {
            if (typeof children === 'number')
                children = [children];
            objectArray = stackAlloc(children.length * 4);
            count = children.length;
            for (var i = 0; i < count; ++i)
                setValue(objectArray + i * 4, children[i], 'i32');
        }
        result = Module._tiramisu_setChildObjects(parentHandle, objectArray, count) !== 0;
        stackRestore(sp);
        return result;
    },

    /**
     * Returns handle of the parent object.
     * 
     * @memberof module:solo.app
     * @param {Handle} [handle] - Parent handle
     * @returns {Handle} Handle of 3D object
     * @since 1.5.1
     */
    getParentObject: function (handle) {
        return Module._tiramisu_getParentObject(handle);
    },

    /**
     * Returns the object visibility code.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @param {QueryObjectVisibilityFlags} [flags=0] =  - Bit field
     * @returns {ObjectVisibilityEnum} The object visibility code
     * @since 1.5.2
     */
    getObjectVisibility: function (handle, flags) {
        return Module._tiramisu_getObjectVisibility(handle, flags);
    },

    /**
     * Enables or disables rendering of a 3D object.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @param {boolean} visible
     * @since 2.3.1
     * @see {@link module:solo.app.isObjectVisible app.isObjectVisible()}
     */
    setObjectVisibility: function (handle, visible) {
        return Module._tiramisu_setObjectVisibility(handle, visible);
    },

    /**
     * Checks whether the 3D object is being rendered.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @returns {boolean}
     * @since 2.3.1
     * @see {@link module:solo.app.setObjectVisibility app.setObjectVisibility()}
     */
    isObjectVisible: function (handle) {
        return !!Module._tiramisu_isObjectVisibile(handle);
    },

    /**
     * Enables or disables rendering of a 3D object if the app.SELECTION_MODE_ISOLATE option is selected.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @param {boolean} isOpaque
     * @since 2.7.4
     * @see {@link module:solo.app.isOpaqueInSeeThroughModes app.isOpaqueInSeeThroughModes()}
     * @see {@link module:solo.app.selectionMode app.selectionMode}
     */
    setOpaqueInSeeThroughModes: function (handle, isOpaque) {
        return Module._tiramisu_setOpaqueInSeeThroughModes(handle, isOpaque);
    },

    /**
     * Checks whether the 3D object is being rendered if the app.SELECTION_MODE_ISOLATE option is selected.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @returns {boolean}
     * @since 2.7.4
     * @see {@link module:solo.app.setOpaqueInSeeThroughModes app.setOpaqueInSeeThroughModes()}
     * @see {@link module:solo.app.selectionMode app.selectionMode}
     */
    isOpaqueInSeeThroughModes: function (handle) {
        return !!Module._isOpaqueInSeeThroughModes(handle);
    },

    /**
     * Returns flags of the 3D object.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @returns {number} Flags of 3D object
     * @since 1.5.2
     */
    getObjectFlags: function (handle) {
        return Module._tiramisu_getObjectFlags(handle);
    },

    /**
     * Returns bounding box of the 3D object.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @param {ObjectBoundingBoxEnum} type
     * @returns {ObjectBoundingBox|null} Bounding box information for 3D object
     * @since 1.8.3
     */
    getObjectBoundingBox: function (handle, type) {
        var sp = stackSave(),
            floatArray = stackAlloc(24),
            success = Module._tiramisu_getObjectBoundingBox(handle, type, floatArray),
            p = floatArray >>> 2,
            bbox = success ? {
                center: [HEAPF32[p], HEAPF32[p + 1], HEAPF32[p + 2]],
                size: [HEAPF32[p + 3], HEAPF32[p + 4], HEAPF32[p + 5]]
            } : null;
        stackRestore(sp);
        return bbox;
    },

    /**
     * Returns bounding box of the 3D object.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @param {ObjectBoundingBoxEnum} type
     * @returns {ObjectBoundingBox|null} Bounding box information for 3D object
     * @since 2.7.4
     */
    getChainBoundingBox: function (chain, type) {
        if (!chain || !chain.length)
            return null;
		var sp = stackSave(),
			floatArray = stackAlloc(24),
            handleArray = stackAlloc(chain.length * 4);
        for (var i = 0, h = handleArray >>> 2; i < chain.length; ++i, ++h)
            HEAPU32[h] = chain[i];
		var success = Module._tiramisu_getObjectBoundingBox(handleArray, type, floatArray, chain.length),
			p = floatArray >>> 2,
			bbox = success ? {
				center: [HEAPF32[p], HEAPF32[p + 1], HEAPF32[p + 2]],
				size: [HEAPF32[p + 3], HEAPF32[p + 4], HEAPF32[p + 5]]
			} : null;
		stackRestore(sp);
		return bbox;
    },

    /**
     * Creates 3D objects from the string.
     * 
     * @memberof module:solo.app
     * @param {string} syntax - VRML syntax string
     * @param {string} [baseUrl] - Base URL to load external resources
     * @returns {Handle[]} An array of 3D object handles
     * @since 1.4.0
     */
    createObjectsFromString: function (syntax, baseUrl) {
        var nodes = Module.ccall('tiramisu_createObjects', 'number', ['string', 'number', 'string'], [syntax, 0, baseUrl || null]),
            handles = unmarshalObjectArray(nodes);
        if (nodes) {
            Module._free(nodes);
        } else {
            Module.printErr('createObjectsFromString() failed: "' + syntax + '"');
        }
        return handles;
    },

    /**
     * _Asynchronous method_. Creates 3D objects from url.
     * 
     * @async
     * @memberof module:solo.app
     * @param {string} url - URl to load VRML file
     * @returns {Promise<Handle[]>} `Promise` whose fulfillment handler receives an array of 3D object handles
     * @see external:Promise
     * @since 1.4.0
     */
    createObjectsFromURL: function (url) {
        return util.loadResource(url, '', 'arraybuffer').then(function (xhr) {
            var arrayBuffer = xhr.response,
                byteArray,
                buffer,
                nodes;
            if (arrayBuffer) {
                byteArray = new Uint8Array(arrayBuffer);
                buffer = _malloc(byteArray.byteLength);
                writeArrayToMemory(byteArray, buffer);
                nodes = Module.ccall('tiramisu_createObjects', 'number', ['number', 'number', 'string'], [buffer, byteArray.byteLength, url]);
                handles = unmarshalObjectArray(nodes);
                Module._free(buffer);
                if (nodes) {
                    Module._free(nodes);
                    return Promise.resolve(handles);
                }
            }
            return Promise.reject(new Error('createObjectsFromURL() failed: "' + url + '"'));
        });
    },

    /**
     * Creates 3D objects from the VRML file in the *.cortona3d* bundle.
     * 
     * @memberof module:solo.app
     * @param {string} itemName - The name of the VRML file in the document bundle
     * @returns {Handle[]} An array of 3D object handles
     * @since 1.4.0
     */
    createObjectsFromDocumentBundle: function (fileName) {
        var nodes = Module.ccall('tiramisu_createObjectsFromBundleItem', 'number', ['string'], [fileName]),
            handles = unmarshalObjectArray(nodes);
        if (nodes) {
            Module._free(nodes);
        } else {
            Module.printErr('createObjectsFromDocumentBundle() failed: "' + fileName + '"');
        }
        return handles;
    },

    /**
     * Gets camera position, orientation, field of view and center of rotation.
     * 
     * @param {object} [props]
     * @param {number[]} [props.location] - Request camera position [x, y, z]
     * @param {number[]} [props.orientation] - Request camera orientation [x, y, z, angle]
     * @param {number} [props.scalarParam] - Request field of view
     * @param {number[]} [props.rotationCenter] - Request center of rotation [x, y, z]
     * @memberof module:solo.app
     * @returns {object} Object with requested location, orientation, scalarParam or rotationCenter
     * @since 2.1.0
     * @see {@link module:solo.app.setCameraProperties app.setCameraProperties()}
     */
    getCameraProperties: function (props) {
        var sp = stackSave(),
            data = stackAlloc(48),
            p = data >>> 2,
            flags;
        if (props) {
            flags = 0;
            if (props.hasOwnProperty('location'))
                flags |= 1;
            if (props.hasOwnProperty('orientation'))
                flags |= 2;
            if (props.hasOwnProperty('scalarParam'))
                flags |= 4;
            if (props.hasOwnProperty('rotationCenter'))
                flags |= 8;
        }
        else {
            flags = 15;
            props = {};
        }
        HEAPU32[p] = flags;
        Module._tiramisu_getCameraProperties(data);
        if (flags & 1)
            props.location = [HEAPF32[p + 1], HEAPF32[p + 2], HEAPF32[p + 3]];
        if (flags & 2)
            props.orientation = [HEAPF32[p + 4], HEAPF32[p + 5], HEAPF32[p + 6], HEAPF32[p + 7]];
        if (flags & 4)
            props.scalarParam = HEAPF32[p + 8];
        if (flags & 8)
            props.rotationCenter = [HEAPF32[p + 9], HEAPF32[p + 10], HEAPF32[p + 11]];
        stackRestore(sp);
        return props;
    },

    /**
     * Sets camera position, orientation, field of view and center of rotation.
     * 
     * @param {object} props 
     * @param {number[]} [props.location] - Camera position [x, y, z]
     * @param {number[]} [props.orientation] - Camera orientation [x, y, z, angle]
     * @param {number} [props.scalarParam] - Field of view. If < 0, then saves the current value.
     * @param {number[]} [props.rotationCenter] - Center of rotation [x, y, z]
     * @param {boolean} [animated]
     * @memberof module:solo.app
     * @since 2.1.0
     * @see {@link module:solo.app.getCameraProperties app.getCameraProperties()}
     */
    setCameraProperties: function (props, animated) {
        var sp = stackSave(),
            data = stackAlloc(48),
            p = data >>> 2,
            flags = 0;

        if (props.location) {
            flags |= 1;
            HEAPF32[p + 1] = props.location[0];
            HEAPF32[p + 2] = props.location[1];
            HEAPF32[p + 3] = props.location[2];
        }
        if (props.orientation) {
            flags |= 2;
            HEAPF32[p + 4] = props.orientation[0];
            HEAPF32[p + 5] = props.orientation[1];
            HEAPF32[p + 6] = props.orientation[2];
            HEAPF32[p + 7] = props.orientation[3];
        }
        if (props.scalarParam && props.scalarParam > 0) {
            flags |= 4;
            HEAPF32[p + 8] = props.scalarParam;
        }
        if (props.rotationCenter) {
            flags |= 8;
            HEAPF32[p + 9] = props.rotationCenter[0];
            HEAPF32[p + 10] = props.rotationCenter[1];
            HEAPF32[p + 11] = props.rotationCenter[2];
        }
        HEAPU32[p] = flags;
        Module._tiramisu_setCameraProperties(data, animated);
        stackRestore(sp);
    },

    /**
     * Returns coordinates in the 3D window for a 3D point.
     * 
     * @param {number[]} scenePoint 3D point [x, y, x]
     * @returns {number[]} Point in the 3D window [x, y]
     * @memberof module:solo.app
     * @since 2.1.0
     * @see {@link module:solo.app.unproject app.unproject()}
     */
    project: function (scenePoint) {
        var sp = stackSave(),
            data = stackAlloc(20),
            p = data >>> 2,
            screenPoint = null;
        HEAPF32[p] = scenePoint[0];
        HEAPF32[p + 1] = scenePoint[1];
        HEAPF32[p + 2] = scenePoint[2];
        if (Module._tiramisu_project(data, data + 12))
            screenPoint = [Math.round(HEAPF32[p + 3]), Math.round(HEAPF32[p + 4])];
        stackRestore(sp);
        return screenPoint;
    },

    /**
     * Sends a ray from the viewer location through a given point in the 3D window and returns coordinates of a point on the ray at a given distance from the viewer. 
     * 
     * > #### __NOTE__
     * > 
     * > This method is only applicable for a perspective camera. 
     * > For an orthographic camera, the distance parameter has no physical sense and the result may be unpredictable.
     * 
     * @param {number[]} screenPoint Point in the 3D window [x, y]
     * @param {number} distance 
     * @returns {number[]} 3D point [x, y, z]
     * @memberof module:solo.app
     * @since 2.1.0
     * @see {@link module:solo.app.project app.project()}
     */
    unproject: function (screenPoint, distance) {
        var sp = stackSave(),
            data = stackAlloc(20),
            p = data >>> 2,
            scenePoint = null;
        HEAPF32[p] = screenPoint[0];
        HEAPF32[p + 1] = screenPoint[1];
        if (Module._tiramisu_unproject(data, distance, data + 8))
            scenePoint = [HEAPF32[p + 2], HEAPF32[p + 3], HEAPF32[p + 4]];
        stackRestore(sp);
        return scenePoint;
    },

    /**
     * Sets the transparency for objects.
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {number} value [-1 ... 1]
     * @param {AnimatedMode} [animated=false]
     * @since 1.6.4
     * @see {@link module:solo.app.setObjectPropertyf app.setObjectPropertyf} about the value of the transparency level
     */
    setObjectsTransparency: function (handles, value, animated) {
        var handlesArray = util.isUndefined(handles) ? [] : (Array.isArray(handles) ? handles : [handles]);
        handlesArray.forEach(function (handle) {
            app.setObjectPropertyf(handle, app.PROPERTY_TRANSPARENCY, animated, value);
        });
    },

    /**
     * Gets the transparency value for objects.
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @returns {number}
     * @since 1.6.4
     * @see {@link module:solo.app.setObjectPropertyf app.setObjectPropertyf} about the value of the transparency level
     */
    getObjectsTransparency: function (handles) {
        var handlesArray = util.isUndefined(handles) ? [] : (Array.isArray(handles) ? handles : [handles]);
        return handlesArray.reduce(function (acc, handle) {
            return Math.max(app.getObjectPropertyf(handle, app.PROPERTY_TRANSPARENCY), acc);
        }, -1);
    },

    /**
     * Toggles the visibility state for objects.
     * 
     * @memberof module:solo.app
     * @param {Handle[]|Handle} handles - Array of 3D object handles or a single handle
     * @param {boolean} [force]
     * @returns {boolean}
     * @since 1.6.4
     */
    toggleObjectsVisibility: function (handles, force) {
        var handlesArray = util.isUndefined(handles) ? [] : (Array.isArray(handles) ? handles : [handles]);
        var isVisible = !force;

        if (typeof force === 'undefined') {
            isVisible = !handlesArray.some(function (handle) {
                return !!app.getObjectVisibility(handle);
            });
        }

        handlesArray.forEach(function (handle) {
            if (isVisible) {
                app.setObjectPropertyf(handle, app.PROPERTY_VISIBILITY, false, -1);
            } else {
                app.restoreObjectProperty(handle, app.PROPERTY_VISIBILITY, false);
            }
        });

        return !isVisible;
    },

    /**
     * Performs single step of navigation in the 3D window according to the type specified in the `action` argument.
     * Optional arguments `arg1` and `arg2` define the necessary parameters depending on the navigation type:
     * - app.NAVIGATOR_ACTION_SPIN   = 0,  `arg1` = offsetX, `arg2` = offsetY
     * - app.NAVIGATOR_ACTION_PAN    = 1,  `arg1` = translationX, `arg2` = translationY
     * - app.NAVIGATOR_ACTION_ZOOM   = 2,  `arg1` = zoomScale
     * - app.NAVIGATOR_ACTION_ROTATE = 3,  `arg1` = angle
     * @memberof module:solo.app
     * @param {NavigatorActionEnum} action
     * @param {number} arg1
     * @param {number} [arg2]
     * @returns {boolean}
     * @since 1.7.0
     * @deprecated since version 2.1.4, use {@link module:solo.app.navigator app.navigator} instead
     */
    navigate: function (action, arg1, arg2) {
        return Module._tiramisu_navigate(action, arg1, arg2);
    },

    /**
     * Creates a snapshot of 3D objects.
     * 
     * @memberof module:solo.app
     * @param {string[]} names - 3D objects names
     * @param {number} width - Image width in pixels
     * @param {number} height - Image height in pixels
     * @param {number[]|0|string} [orientation] - Orientation of the camera as an array of 4 floating-point numbers [x, y, z, angle]. Default value is [-0.12449, -0.94561, -0.30055, 2.39496]. 
     * Use 0 to define the default value.
     * You can also use names for predefined camera orientations:
     * - "front"
     * - "back"
     * - "left"
     * - "right"
     * - "top"
     * - "bottom"
     * - "isometric"
     * - "default"
     * @param {SnapshotFlags} [options] - Bit field
     * @returns {string|null} Data URL with snapshot image
     * @since 2.0.1
     */
    makeSnapshot: function (names, width, height, orientation, options) {
        var sp = stackSave(),
            nodeNames = stackAlloc(4 * names.length),
            p = nodeNames >>> 2;

        names.forEach(function (name) {
            var size = lengthBytesUTF8(name) + 1,
                cstr = stackAlloc(size);
            stringToUTF8Array(name, HEAP8, cstr, size);
            HEAP32[p] = cstr;
            ++p;
        });

        var data = Module._tiramisu_makeSnapshot(nodeNames, names.length, width, height, toRotation(getCameraOrientation(orientation)), options || 0);
        stackRestore(sp);
        if (!data)
            return null;
        var canvas = getCanvasWithImageData(data);
        Module._free(data);
        return canvas.toDataURL();
    },

    /**
     * Creates a snapshot of 3D scene.
     * 
     * @memberof module:solo.app
     * @param {number} width - Image width in pixels
     * @param {number} height - Image height in pixels
     * @param {number[]|0|string} [orientation] - Orientation of the camera as an array of 4 floating-point numbers [x, y, z, angle]. Default value is [-0.12449, -0.94561, -0.30055, 2.39496]. 
     * Use 0 to define the default value.
     * You can also use names for predefined camera orientations:
     * - "front"
     * - "back"
     * - "left"
     * - "right"
     * - "top"
     * - "bottom"
     * - "isometric"
     * - "default"
     * @param {SnapshotFlags} [options] - Bit field
     * @param {number} [dpi=96]
     * @returns {Promise<string>} `Promise` whose fulfillment handler receives a data URL with snapshot image
     * @since 2.1.3
     */
    makeSceneSnapshot: function (width, height, orientation, options, dpi) {
        dpi = dpi || 96;

        var sp = stackSave();
        var rotation = toRotation(getCameraOrientation(orientation));
        var data = Module._tiramisu_makeSnapshot(0, 0, width, height, rotation, options);

        if (!data) {
            stackRestore(sp);
            return Promise.reject('An error has occurred while creating scene snapshot');
        }

        var canvas = getCanvasWithImageData(data);
        Module._free(data);

        if (!PanelService.hasVisiblePanel()) {
            stackRestore(sp);
            return Promise.resolve(canvas.toDataURL());
        }

        // use DPI = 96 for panels
        var k = dpi / 96 / (window.devicePixelRatio || 1),
            widthPanels = width / k,
            heightPanels = height / k;
        var data = Module._tiramisu_makeSnapshot(0, 0, widthPanels, heightPanels, rotation, options)
        if (data) {
            Module._free(data);
        }
        stackRestore(sp);

        var panelImage = makePanelSnaphot(widthPanels, heightPanels);
        return new Promise(function (resolve, reject) {
            panelImage.onload = function () {
                canvas.getContext('2d').drawImage(panelImage, 0, 0, canvas.width, canvas.height);
                resolve(canvas.toDataURL());
            }
            panelImage.onerror = function (e) {
                reject('An error has occurred while creating panel snapshot');
            }
        });
    },

    /**
     * Executes a query to determine the occlusion of objects.
     * 
     * @memberof module:solo.app
     * @param {QueryObjectOcclusionFlags} [options] - Bit field
     * @returns {QueryObjectOcclusionResult}
     * @since 2.1.0
     */
    queryObjectOcclusion: function (options) {
        var query = Module._tiramisu_queryObjectOcclusion(options),
            results = Object.create(null),
            p;
        if (query)
            for (p = query >>> 2; HEAPU32[p]; p += 2)
                results[HEAPU32[p]] = HEAPU32[p + 1];
        Module._free(query);
        return results;
    },

    /**
     * Starts object visibility tracking.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @since 2.6.1
     * @see {@link event:"app.didChangeVisibility" "app.didChangeVisibility"}
     * @see {@link module:solo.app.cancelVisibilityObservation app.cancelVisibilityObservation}
     */
    observeObjectVisibility: function (handle) {
        Module._tiramisu_observeObjectVisibility(handle);
    },

    /**
     * Cancels object visibility tracking.
     * 
     * @memberof module:solo.app
     * @param {Handle} handle - Handle of 3D object
     * @since 2.6.1
     * @see {@link event:"app.didChangeVisibility" "app.didChangeVisibility"}
     * @see {@link module:solo.app.observeObjectVisibility app.observeObjectVisibility}
     */
    cancelVisibilityObservation: function (handle) {
        Module._tiramisu_cancelVisibilityObservation(handle);
    },

    /**
     * Adds a new section plane to the model.
     * 
     * @memberof module:solo.app
     * @returns {SectionPlane} The instance of SectionPlane object
     * @since 2.6.1
     * @see {@link module:solo.app.removeSectionPlane app.removeSectionPlane}
     */
    addSectionPlane: function () {
        return new SectionPlane(Module._tiramisu_addSectionPlane());
    },

    /**
     * Removes the section plane from the model.
     * 
     * @memberof module:solo.app
     * @param {SectionPlane} sectionPlane The instance of SectionPlane object
     * @since 2.6.1
     * @see {@link module:solo.app.addSectionPlane app.addSectionPlane}
     */
    removeSectionPlane: function (sectionPlane) {
        Module._tiramisu_removeSectionPlane(sectionPlane[Symbol.for('peer')]);
        sectionPlane[Symbol.for('peer')] = 0;
    }
};

Object.defineProperties(app, {
    /**
     * Gets or sets the global color for drawing edges.
     * 
     * @static
     * @member {HexColorString} globalEdgeColor
     * @memberof module:solo.app
     * @since 1.5.7
     */
    'globalEdgeColor': {
        get: function () {
            return millicolor(Module._tiramisu_getGlobalEdgeColor()).toString()
        },
        set: function (color) {
            Module._tiramisu_setGlobalEdgeColor(millicolor(color).toValue());
        },
        enumerable: true
    },
    /**
     * Gets or sets the weights for the drawing edges as an array of three float numbers. Default value is `[0, 0, 0]`.
     * 
     * The color is calculated by the formula:
     * 
     * `edgeColor = globalEdgeColor * weights[0] + material.diffuseColor * weights[1] + material.emissiveColor * weights[2]`
     * 
     * If the value is `[0, 0, 0]` then edge drawing will be disabled.
     * 
     * @static
     * @member {number[]} edgeColorWeights
     * @memberof module:solo.app
     * @since 1.5.7
     * @see {@link module:solo.app.globalEdgeColor app.globalEdgeColor}
     */
    'edgeColorWeights': {
        get: function () {
            var p = Module._tiramisu_getEdgeColorWeights() >>> 2;
            return [HEAPF32[p], HEAPF32[p + 1], HEAPF32[p + 2]];
        },
        set: function (weights) {
            var sp = stackSave(),
                weightArray = stackAlloc(3 * 4);
            assignVec3f(weightArray, weights);
            Module._tiramisu_setEdgeColorWeights(weightArray);
            stackRestore(sp);
        },
        enumerable: true
    },
    /**
     * Gets or sets the object selection mode.
     * 
     * @static
     * @member {SelectionModeEnum} selectionMode
     * @memberof module:solo.app
     * @since 2.0.0
     * @see {@link module:solo.app.selectionColor app.selectionColor}
     * @see {@link module:solo.app.setSelectedObjects app.setSelectedObjects}
     * @see {@link module:solo.app.addSelectedObjects app.addSelectedObjects}
     * @see {@link module:solo.app.ipc.selectItem app.ipc.selectItem}
     * @see {@link module:solo.app.setOpaqueInSeeThroughModes app.setOpaqueInSeeThroughModes()}
     * @see {@link module:solo.app.isOpaqueInSeeThroughModes app.isOpaqueInSeeThroughModes()}
     */
    'selectionMode': {
        get: function () {
            return Module._tiramisu_getSelectionRenderingMode();
        },
        set: function (mode) {
            var m = +mode || 0;
            if (m === 2 && !Module._tiramisu_isTranslucentShellSupported()) {
                console.info(NEED_WEBGL2 + ' to use app.selectionMode = app.SELECTION_MODE_TRANSLUCENT_SHELL');
                return;
            }
            Module._tiramisu_setSelectionRenderingMode(m);
        },
        enumerable: true
    },
    /**
     * Gets or sets the mode for drawing the outline of highlighted (hovered) objects.
     * 
     * @static
     * @member {boolean} outlineHoveredObjects
     * @memberof module:solo.app
     * @since 2.0.0
     * @see {@link module:solo.app.outlineParams app.outlineParams}
     */
    'outlineHoveredObjects': {
        get: function () {
            return !!Module._tiramisu_isOutlineHoveredObjectsEnabled();
        },
        set: function (enable) {
            if (!Module._tiramisu_isOutlineHoveredObjectsSupported() && enable) {
                console.info(NEED_WEBGL2 + ' to use app.outlineHoveredObjects = true');
                return;
            }
            Module._tiramisu_enableOutlineHoveredObjects(enable);
        },
        enumerable: true
    },
    /**
     * Enables or disables the use of the ambient occlusion in the scene.
     * 
     * > #### __NOTE__
     * >
     * > To use the ambient occlusion, you must set the {@link module:solo.app ENABLE_GLES3} and {@link module:solo.app DISABLE_ANTIALIASING_GLES3} flags before the library is initialized.
     * >```
     * >    Cortona3DSolo.use('core', { 
     * >        features: Cortona3DSolo.app.ENABLE_GLES3 | Cortona3DSolo.app.DISABLE_ANTIALIASING_GLES3
     * >    });
     * >    Cortona3DSolo.app.initialize('scene.wrl');
     * >```
     *
     * @static
     * @member {boolean} ambientOcclusion
     * @memberof module:solo.app
     * @since 2.0.0
     */
    'ambientOcclusion': {
        get: function () {
            return !!Module._tiramisu_isAmbientOcclusionEnabled();
        },
        set: function (enable) {
            if (enable && !checkConfigureOptions(app.ENABLE_GLES3 + app.DISABLE_ANTIALIASING_GLES3)) {
                console.info('To use the ambient occlusion' + NEED_WEBGL2);
            }
            Module._tiramisu_enableAmbientOcclusion(enable);
        },
        enumerable: true
    },
    /**
     * Gets or sets parameters of the ambient occlusion.
     * 
     * @static
     * @member {object} ambientOcclusionParams
     * @memberof module:solo.app
     * @property {number} [kernelSize]
     * @property {number} [radius]
     * @property {number} [intensity]
     * @since 2.0.0
     * @see {@link module:solo.app.ambientOcclusion app.ambientOcclusion}
     */
    'ambientOcclusionParams': {
        get: function () {
            var p = Module._tiramisu_getAmbientOcclusionParams() >>> 2;
            return {
                kernelSize: HEAP32[p],
                radius: HEAPF32[p + 1],
                intensity: HEAPF32[p + 2]
            };
        },
        set: function (params) {
            var p0 = Module._tiramisu_getAmbientOcclusionParams() >>> 2,
                sp = stackSave(),
                mem = stackAlloc(12),
                p = mem >>> 2;

            HEAP32[p] = params.kernelSize ? params.kernelSize : HEAP32[p0];
            HEAPF32[p + 1] = params.radius ? params.radius : HEAPF32[p0 + 1];
            HEAPF32[p + 2] = params.intensity ? params.intensity : HEAPF32[p0 + 2];

            Module._tiramisu_setAmbientOcclusionParams(mem);

            stackRestore(sp);
        }
    },
    /**
     * Gets or sets the lighting configuration.
     * 
     * @static
     * @member {LightingConfig[]} lightingConfig
     * @memberof module:solo.app
     * @since 2.0.0
     */
    'lightingConfig': {
        get: function () {
            var lightCount = Module._tiramisu_getLightingConfig(0, 0),
                sp = stackSave(),
                mem = stackAlloc(lightCount * 32),
                p = mem >>> 2,
                config = [], i;
            lightCount = Module._tiramisu_getLightingConfig(mem, lightCount);
            for (i = 0; i < lightCount; ++i) {
                config.push({
                    color: millicolor([HEAPF32[p + 0], HEAPF32[p + 1], HEAPF32[p + 2]]).toString(),
                    direction: [HEAPF32[p + 3], HEAPF32[p + 4], HEAPF32[p + 5]],
                    intensity: HEAPF32[p + 6],
                    ambientIntensity: HEAPF32[p + 7]
                });
                p += 8;
            }
            stackRestore(sp);
            return config;
        },
        set: function (config) {
            var sp = stackSave(),
                mem = stackAlloc(config.length * 32),
                p = mem >>> 2, i, l, color;
            for (i = 0; i < config.length; ++i) {
                l = config[i];
                color = typeof l.color !== 'undefined' ? millicolor(l.color).toArray() : [1, 1, 1];
                HEAPF32[p] = color[0];
                HEAPF32[p + 1] = color[1];
                HEAPF32[p + 2] = color[2];
                HEAPF32[p + 3] = l.direction ? l.direction[0] : 0;
                HEAPF32[p + 4] = l.direction ? l.direction[1] : 0;
                HEAPF32[p + 5] = l.direction ? l.direction[2] : -1;
                HEAPF32[p + 6] = l.intensity ? l.intensity : 1;
                HEAPF32[p + 7] = l.ambientIntensity ? l.ambientIntensity : 0;
                p += 8;
            }
            Module._tiramisu_setLightingConfig(mem, config.length);
            stackRestore(sp);
        }
    },
    /**
     * Gets or sets outline parameters for the hovered objects.
     * 
     * @static
     * @member {object} outlineParams
     * @memberof module:solo.app
     * @property {number[]} visibleEdgeColor [r, g, b, a], where r,g,b,a := [0...1]
     * @property {number[]} invisibleEdgeColor [r, g, b, a]
     * @property {number[]} invisibleFillColor [r, g, b, a]
     * @property {number} pixelSize
     * @since 2.0.0
     */
    'outlineParams': {
        get: function () {
            var p = Module._tiramisu_getOutlineParams() >>> 2;
            return {
                visibleEdgeColor: [HEAPF32[p], HEAPF32[p + 1], HEAPF32[p + 2], HEAPF32[p + 3]],
                invisibleEdgeColor: [HEAPF32[p + 4], HEAPF32[p + 5], HEAPF32[p + 6], HEAPF32[p + 7]],
                invisibleFillColor: [HEAPF32[p + 8], HEAPF32[p + 9], HEAPF32[p + 10], HEAPF32[p + 11]],
                size: HEAP32[p + 12]
            };
        },
        set: function (params) {
            var p0 = Module._tiramisu_getOutlineParams() >>> 2,
                sp = stackSave(),
                mem = stackAlloc(52),
                p = mem >>> 2;

            function assignColor(offset, value) {
                if (value && value.length > 3) {
                    HEAPF32[p + offset] = value[0];
                    HEAPF32[p + offset + 1] = value[1];
                    HEAPF32[p + offset + 2] = value[2];
                    HEAPF32[p + offset + 3] = value[3];
                }
                else {
                    HEAPF32[p + offset] = HEAPF32[p0 + offset];
                    HEAPF32[p + offset + 1] = HEAPF32[p0 + offset + 1];
                    HEAPF32[p + offset + 2] = HEAPF32[p0 + offset + 2];
                    HEAPF32[p + offset + 3] = HEAPF32[p0 + offset + 3];
                }
            }

            assignColor(0, params.visibleEdgeColor);
            assignColor(4, params.invisibleEdgeColor);
            assignColor(8, params.invisibleFillColor);
            HEAP32[p + 12] = params.size ? params.size : HEAP32[p0 + 12];

            Module._tiramisu_setOutlineParams(mem);

            stackRestore(sp);
        }
    },
    /**
     * Enables or disables the use of FXAA anti-aliasing in the scene (disabled by default).
     * 
     * > #### __NOTE__
     * >
     * > To use FXAA anti-aliasing, you must set the {@link module:solo.app ENABLE_GLES3} and {@link module:solo.app DISABLE_ANTIALIASING_GLES3} flags before the library is initialized.
     * >```
     * >    Cortona3DSolo.use('core', { 
     * >        features: Cortona3DSolo.app.ENABLE_GLES3 | Cortona3DSolo.app.DISABLE_ANTIALIASING_GLES3
     * >    });
     * >    Cortona3DSolo.app.initialize('scene.wrl');
     * >```
     *
     * @static
     * @member {boolean} antialiasing
     * @memberof module:solo.app
     * @since 2.0.0
     */
    'antialiasing': {
        get: function () {
            var isGLES3 = checkConfigureOptions(app.ENABLE_GLES3),
                noMSAA = isGLES3 && checkConfigureOptions(app.DISABLE_ANTIALIASING_GLES3);
            return noMSAA ? !!Module._tiramisu_isAntialiasingEnabled() : !isGLES3;
        },
        set: function (enabled) {
            if (!checkConfigureOptions(app.ENABLE_GLES3 + app.DISABLE_ANTIALIASING_GLES3)) {
                console.info('To use FXAA anti-aliasing' + NEED_WEBGL2);
            }
            Module._tiramisu_enableAntialiasing(enabled);
        },
        enumerable: true
    },
    /**
     * Checks if the ambient occlusion available for use.
     * 
     * @static
     * @member {boolean} ambientOcclusionSupported
     * @readonly
     * @memberof module:solo.app
     * @since 1.5.0
     */
    'ambientOcclusionSupported': {
        get: function () {
            return !!Module._tiramisu_isAmbientOcclusionSupported();
        },
        enumerable: true
    },
    /**
     * Checks whether the camera is animated in the scene.
     * 
     * @static
     * @member {boolean} isAnimatingCamera
     * @readonly
     * @memberof module:solo.app
     * @since 2.1.4
     */
    'isAnimatingCamera': {
        get: function () {
            return !!Module._tiramisu_isAnimatingCamera();
        },
        enumerable: true
    },
    /**
     * Gets or sets the color of the hovered 3D object in the interactive model.
     * 
     * @static
     * @member {HexColorString} hoverColor
     * @memberof module:solo.app
     * @since 1.5.0
     */
    'hoverColor': {
        get: function () {
            return millicolor(Module._tiramisu_getHoverColor()).toString()
        },
        set: function (color) {
            Module._tiramisu_setHoverColor(millicolor(color).toValue());
        },
        enumerable: true
    },
    /**
     * Gets or sets the color of the selected 3D object in the interactive model.
     * 
     * @static
     * @member {HexColorString} selectionColor
     * @memberof module:solo.app
     * @since 1.5.0
     */
    'selectionColor': {
        get: function () {
            return millicolor(Module._tiramisu_getSelectionColor()).toString();
        },
        set: function (color) {
            Module._tiramisu_setSelectionColor(millicolor(color).toValue());
        },
        enumerable: true
    },
    /**
     * Gets or sets the transparency threshold used by the picker. The value is [0..1].
     * 
     * The picker ignores shapes with transparency level greater or equal than threshold value.
     * 
     * Except:
     * - 0 - shapes with any transparency level are ignored, except of fully opaque shapes;
     * - -1 - disables filtering of objects based on transparency.
     * 
     * Default value:
     * - 0 - for catalog and procedure;
     * - -1 - for generic VRML.
     * 
     * @static
     * @member {number} pickerTransparencyThreshold
     * @memberof module:solo.app
     * @since 1.5.0
     */
    'pickerTransparencyThreshold': {
        get: function () {
            value = Module._tiramisu_getPickerTransparencyThreshold();
            if (value < 0) value = -1;
            return (value >= 0 && value <= MIN_PICKER_TRANSPARENCY_THRESHOLD) ? 0 : value;
        },
        set: function (value) {
            Module._tiramisu_setPickerTransparencyThreshold(value || MIN_PICKER_TRANSPARENCY_THRESHOLD);
        },
        enumerable: true
    },
    /**
     * Gets a description of the loaded interactive model.
     * 
     * @static
     * @member {DocumentInfo} modelInfo
     * @readonly
     * @memberof module:solo.app
     * @since 1.5.0
     */
    'modelInfo': {
        get: function () {
            return m_doc && expand({}, m_doc);
        },
        enumerable: true
    },
    /**
     * Gets or sets the active viewpoint in the 3D scene.
     * 
     * @static
     * @member {Handle} activeViewpoint
     * @memberof module:solo.app
     * @since 1.5.0
     */
    'activeViewpoint': {
        get: function () {
            return Module._tiramisu_getActiveViewpoint();
        },
        set: function (handle) {
            Module._tiramisu_setActiveViewpoint(handle);
        },
        enumerable: true
    },
    /**
     * Gets or sets a flag for recursive object lookup. 
     * It must be set to `true` if the hierarchy of 3D objects is kept in VRML.
     * Default value is `false` for the catalog and `true` for the procedure or the catalog with `keep3DStructure` feature.
     * 
     * @static
     * @member {boolean} recursiveObjectLookup
     * @memberof module:solo.app
     * @since 1.6.0
     */
    'recursiveObjectLookup': {
        get: function () {
            if (Module._tiramisu_isRecursiveObjectLookupEnabled) {
                return !!Module._tiramisu_isRecursiveObjectLookupEnabled();
            }
            return m_recursiveObjectLookup;
        },
        set: function (enabled) {
            if (Module._tiramisu_enableRecursiveObjectLookup) {
                Module._tiramisu_enableRecursiveObjectLookup(enabled);
            }
            else {
                m_recursiveObjectLookup = enabled;
            }

        },
        enumerable: true
    },
    /**
     * Gets or sets the visibility flag for the coordinate axes.
     * 
     * @static
     * @member {boolean} coordinateAxesVisible
     * @memberof module:solo.app
     * @since 1.8.1
     */
    'coordinateAxesVisible': {
        get: function () {
            return !!Module._tiramisu_isCoordinateAxesVisible();
        },
        set: function (enabled) {
            Module._tiramisu_setCoordinateAxesVisibility(enabled);
        },
        enumerable: true
    },
    /**
     * Gets or sets the visibility flag for the center of rotation.
     * 
     * @static
     * @member {boolean} rotationCenterVisible
     * @memberof module:solo.app
     * @since 1.8.1
     */
    'rotationCenterVisible': {
        get: function () {
            return !!Module._tiramisu_isRotationCenterVisible();
        },
        set: function (enabled) {
            Module._tiramisu_setRotationCenterVisibility(enabled);
        },
        enumerable: true
    },
    /**
     * Gets or sets the display mode of hovered objects in the translucent shell mode.
     * 
     * @static
     * @member {boolean} drawHoveredObjectsAsSelected
     * @memberof module:solo.app
     * @since 2.6.0
     */
    'drawHoveredObjectsAsSelected': {
        get: function () {
            return !!Module._tiramisu_isDrawHoveredObjectsAsSelected();
        },
        set: function (enabled) {
            Module._tiramisu_setDrawHoveredObjectsAsSelected(enabled);
        },
        enumerable: true
    },
    /**
     * Gets or sets the rendering mode of the context geometry.
     * 
     * > #### __NOTE__ (for versions prior to 2.7.4)
     * >
     * > Switching the {@link module:solo.app.backgroundGeometryRenderingMode app.backgroundGeometryRenderingMode} mode affects the {@link module:solo.app.selectionMode app.selectionMode} mode: 
     * > if it is impossible to render in the selected combination, the {@link module:solo.app.selectionMode app.selectionMode} will switch to “color” {app.SELECTION_MODE_DEFAULT=0}.
     * > Similarly, switching the {@link module:solo.app.selectionMode app.selectionMode} mode affects the {@link module:solo.app.backgroundGeometryRenderingMode app.backgroundGeometryRenderingMode} mode: 
     * > if it is impossible to draw in the selected combination, the {@link module:solo.app.backgroundGeometryRenderingMode app.backgroundGeometryRenderingMode} will switch to “default” (app.GEOMETRY_RENDERING_MODE_DEFAULT=0).
     * >
     * > Incompatible combinations: XRay/TranslucentShell or TranslucentShell/XRay.
     * 
     * @static
     * @member {GeometryRenderingModeEnum} backgroundGeometryRenderingMode
     * @memberof module:solo.app
     * @since 2.6.0
     */
    'backgroundGeometryRenderingMode': {
        get: function () {
            return Module._tiramisu_getContextGeometryRenderingMode();
        },
        set: function (mode) {
            Module._tiramisu_setContextGeometryRenderingMode(mode);
        },
        enumerable: true
    },
    /**
     * Gets or sets options for the navigation mode.
     * 
     * @static
     * @member {NavigatorOptionsFlags} navigatorOptions
     * @memberof module:solo.app
     * @since 1.8.2
     * @deprecated since version 2.1.4, use {@link module:solo.app.navigator app.navigator} instead
     */
    'navigatorOptions': {
        get: function () {
            var value = Module._tiramisu_getNavigatorOptions();
            if (!checkConfigureOptions(app.DISABLE_DISCARDABLE_GEOMETRY_DATA)) {
                value &= ~(app.AUTOMATIC_ZOOM_ANCHOR + app.AUTOMATIC_SPIN_CENTER);
            }
            return value;
        },
        set: function (options) {
            Module._tiramisu_setNavigatorOptions(options);
        },
        enumerable: true
    },
    /**
     * Gets or sets the default value for the fit factor to the object.
     * 
     * @static
     * @member {number} defaultFitFactorObject=0.5
     * @memberof module:solo.app
     * @since 1.8.3
     * @see {@link module:solo.app.fitSelectedObjectsInView app.fitSelectedObjectsInView()}
     * @see {@link module:solo.app.fitObjectsInView app.fitObjectsInView()}
     */
    'defaultFitFactorObject': {
        get: function () {
            return m_fitFactorObject;
        },
        set: function (value) {
            m_fitFactorObject = value;
        },
        enumerable: true
    },
    /**
     * Gets or sets the default value for the fit factor to the scene.
     * 
     * @static
     * @member {number} defaultFitFactorScene=0.95
     * @memberof module:solo.app
     * @since 1.8.3
     * @see {@link module:solo.app.jumpToStandardView app.jumpToStandardView()}
     * @see {@link module:solo.app.fitSceneInView app.fitSceneInView()}
     */
    'defaultFitFactorScene': {
        get: function () {
            return m_fitFactorScene;
        },
        set: function (value) {
            m_fitFactorScene = value;
        },
        enumerable: true
    },
    'navigationCube': {
        value: new navCube.NavigationCube(m_navigationCube),
        enumerable: true
    },
    'navigator': {
        value: (function () {
            var n = new Navigator();
            if (Cortona3DSolo.app && Cortona3DSolo.app.navigator) {
                n.inertiaDecelerationFactor = Cortona3DSolo.app.navigator.inertiaDecelerationFactor;
                n.inertiaDisabled = Cortona3DSolo.app.navigator.inertiaDisabled;
            }
            return n;
        })(),
        enumerable: true
    },
    /**
     * Checks whether the camera is orthographic.
     * 
     * @static
     * @readonly
     * @member {boolean} isOrthographicCamera
     * @memberof module:solo.app
     * @since 2.3.1
     */
    'isOrthographicCamera': {
        get: function () { return !!Module._tiramisu_isOrthographicCamera(); },
        enumerable: true
    },
    /**
     * Returns presets for the scene lighting:
     * - 0 - front
     * - 1 - top left + bottom right
     * - 2 - top right + top left
     * - 3 - front + top right + top left
     * - 4 - front + top right + top left  + top
     * - 5 - top right + top left  + top + bottom right + bottom left
     * - 6 - front + top right + top left  + top + bottom right + bottom left
     * 
     * @static
     * @readonly
     * @member {LightingConfig[][]} lightingPresets
     * @memberof module:solo.app
     * @since 2.4.2
     */
    'lightingPresets': {
        get: function () {
            return [
                [0.00, 0, 1.00],
                [0.12, 2, 0.95, 4, 0.45],
                [0.12, 1, 0.74, 2, 0.68],
                [0.12, 0, 0.15, 1, 0.74, 2, 0.68],
                [0.12, 0, 0.15, 1, 0.74, 2, 0.45, 3, 0.15],
                [0.12, 1, 0.68, 2, 0.40, 3, 0.15, 4, 0.23, 5, 0.23],
                [0.05, 0, 0.15, 1, 0.85, 2, 0.45, 3, 0.10, 4, 0.10, 5, 0.10],
            ].map(function (data) {
                var directions = [
                    0, 0, -1, // (0) front,
                    -1, -1, -1, // (1) top right,
                    1, -1, -1, // (2) top left,
                    0, -1, -1, // (3) top,
                    -1, 1, -1, // (4) bottom right
                    1, 1, -1, // (5) bottom left,
                    0, 1, -1, // (6) bottom,
                ];
                var preset = [],
                    lightCount = (data.length - 1) >>> 1;
                for (let i = 0; i < lightCount; ++i) {
                    const d = 3 * data[1 + 2 * i];
                    preset.push({
                        color: [1, 1, 1],
                        direction: [directions[d], directions[d + 1], directions[d + 2]],
                        intensity: data[2 + 2 * i],
                        ambientIntensity: i == 0 ? data[0] : 0
                    });
                }
                return preset;
            });
        },
        enumerable: true
    }
});

Object.defineProperty(app, 'MOUSE_DRAG_MODE_SPIN', {
    value: 0,
    writable: false
});
Object.defineProperty(app, 'MOUSE_DRAG_MODE_PAN', {
    value: 1,
    writable: false
});
Object.defineProperty(app, 'MOUSE_DRAG_MODE_ZOOM', {
    value: 2,
    writable: false
});
Object.defineProperty(app, 'MOUSE_DRAG_MODE_DEFAULT', {
    value: 0,
    writable: false
});

Object.defineProperty(app, 'PROPERTY_DIFFUSE_COLOR', {
    value: 0,
    writable: false
});
Object.defineProperty(app, 'PROPERTY_EMISSIVE_COLOR', {
    value: 1,
    writable: false
});
Object.defineProperty(app, 'PROPERTY_TRANSPARENCY', {
    value: 2,
    writable: false
});
Object.defineProperty(app, 'PROPERTY_VISIBILITY', {
    value: 3,
    writable: false
});
Object.defineProperty(app, 'PROPERTY_TRANSLATION', {
    value: 4,
    writable: false
});
Object.defineProperty(app, 'PROPERTY_ROTATION', {
    value: 5,
    writable: false
});
Object.defineProperty(app, 'PROPERTY_SCALE', {
    value: 6,
    writable: false
});
Object.defineProperty(app, 'PROPERTY_CLIP_PROTECTED', {
    value: 7,
    writable: false
});

Object.defineProperty(app, 'MR_PARTNUMBER', {
    value: 1,
    writable: false
});
Object.defineProperty(app, 'MR_PARTDESC', {
    value: 2,
    writable: false
});
Object.defineProperty(app, 'MR_ITEM', {
    value: 3,
    writable: false
});
Object.defineProperty(app, 'MR_ITEMVAR', {
    value: 4,
    writable: false
});
Object.defineProperty(app, 'MR_INDENT', {
    value: 5,
    writable: false
});
Object.defineProperty(app, 'MR_UPA', {
    value: 6,
    writable: false
});
Object.defineProperty(app, 'MR_TOTALQTY', {
    value: 7,
    writable: false
});

Object.defineProperty(app, 'OBJECT_VISIBILITY_VISIBLE', {
    value: 0,
    writable: false
});
Object.defineProperty(app, 'OBJECT_VISIBILITY_HIDDEN', {
    value: 1,
    writable: false
});
Object.defineProperty(app, 'OBJECT_VISIBILITY_TRANSPARENT', {
    value: 2,
    writable: false
});
Object.defineProperty(app, 'OBJECT_VISIBILITY_IMPLICITLY_HIDDEN', {
    value: 3,
    writable: false
});

Object.defineProperty(app, 'NAVIGATOR_ACTION_SPIN', {
    value: 0,
    writable: false
});
Object.defineProperty(app, 'NAVIGATOR_ACTION_PAN', {
    value: 1,
    writable: false
});
Object.defineProperty(app, 'NAVIGATOR_ACTION_ZOOM', {
    value: 2,
    writable: false
});
Object.defineProperty(app, 'NAVIGATOR_ACTION_ROTATE', {
    value: 3,
    writable: false
});

Object.defineProperty(app, 'AUTOMATIC_ZOOM_ANCHOR', {
    value: 1,
    writable: false
});
Object.defineProperty(app, 'AUTOMATIC_SPIN_CENTER', {
    value: 2,
    writable: false
});
Object.defineProperty(app, 'DISABLE_ZOOM_SCALE_LIMITS', {
    value: 4,
    writable: false
});

Object.defineProperty(app, 'OBJECT_BOUNDING_BOX_LOCAL', {
    value: 0,
    writable: false
});
Object.defineProperty(app, 'OBJECT_BOUNDING_BOX_GLOBAL', {
    value: 1,
    writable: false
});
Object.defineProperty(app, 'OBJECT_BOUNDING_BOX_EXACT', {
    value: 2,
    writable: false
});

Object.defineProperty(app, 'SELECTION_MODE_ISOLATE', {
    value: -1,
    writable: false
});
Object.defineProperty(app, 'SELECTION_MODE_DEFAULT', {
    value: 0,
    writable: false
});
Object.defineProperty(app, 'SELECTION_MODE_XRAY', {
    value: 1,
    writable: false
});
Object.defineProperty(app, 'SELECTION_MODE_TRANSLUCENT_SHELL', {
    value: 2,
    writable: false
});

Object.defineProperty(app, 'GEOMETRY_RENDERING_HIDDEN', {
    value: -1,
    writable: false
});
Object.defineProperty(app, 'GEOMETRY_RENDERING_DEFAULT', {
    value: 0,
    writable: false
});
Object.defineProperty(app, 'GEOMETRY_RENDERING_XRAY', {
    value: 1,
    writable: false
});
Object.defineProperty(app, 'GEOMETRY_RENDERING_TRANSLUCENT_SHELL', {
    value: 2,
    writable: false
});

Object.defineProperty(app, 'OBJECT_HIGHLIGHT_HOVERED', {
    value: 0,
    writable: false
});
Object.defineProperty(app, 'OBJECT_HIGHLIGHT_SELECTED', {
    value: 1,
    writable: false
});
Object.defineProperty(app, 'OBJECT_HIGHLIGHT_SELECTED_HOVERED', {
    value: 2,
    writable: false
});

Object.defineProperty(app, 'SNAPSHOT_DEFAULT', {
    value: 0,
    writable: false
});
Object.defineProperty(app, 'SNAPSHOT_UNDO_FIELD_VALUE_CHANGES', {
    value: 1,
    writable: false
});
Object.defineProperty(app, 'SNAPSHOT_USE_CURRENT_CAMERA_ORIENTATION', {
    value: 2,
    writable: false
});
Object.defineProperty(app, 'SNAPSHOT_REVEAL_HIDDEN_OBJECTS', {
    value: 4,
    writable: false
});
Object.defineProperty(app, 'SNAPSHOT_USE_SCENE_CAMERA', {
    value: 8,
    writable: false
});
Object.defineProperty(app, 'SNAPSHOT_USE_SCENE_BACKGROUND', {
    value: 16,
    writable: false
});

Object.defineProperty(app, 'QUERY_OBJECT_OCCLUSION_IMMEDIATE_PARENT', {
    value: 0x100,
    writable: false
});
Object.defineProperty(app, 'QUERY_OBJECT_OCCLUSION_TOP_LEVEL_PARENT', {
    value: 0x200,
    writable: false
});

Object.defineProperty(app, 'INCLUDE_HIDDEN_CONTEXT_GEOMETRY', {
    value: 1,
    writable: false
});
Object.defineProperty(app, 'INCLUDE_ISOLATED_SELECTED_OBJECTS', {
    value: 2,
    writable: false
});

module.exports = {
    app: appExports
};

/**
 * Unique identifier of the 3D object in the core.
 * @typedef {number} Handle
 */

/**
 * Object bounding box type.
 * 
 * > #### __NOTE__
 * >
 * > The {@link ObjectBoundingBoxEnum OBJECT_BOUNDING_BOX_EXACT} flag is reserved for the future.
 * 
 * @prop {number} app.OBJECT_BOUNDING_BOX_LOCAL=0
 * @prop {number} app.OBJECT_BOUNDING_BOX_GLOBAL=1
 * @prop {number} app.OBJECT_BOUNDING_BOX_EXACT=2
 * @typedef {number} ObjectBoundingBoxEnum
 * @see {@link module:solo.app.getObjectBoundingBox app.getObjectBoundingBox()}
 */

/**
 * Selection mode type.
 * 
 * @prop {number} app.SELECTION_MODE_ISOLATE=-1 Only selected objects are rendered.
 * @prop {number} app.SELECTION_MODE_DEFAULT=0 Selected objects are rendered in the selection color.
 * @prop {number} app.SELECTION_MODE_XRAY=1 All objects except the selected ones are rendered translucent and monochrome.
 * @prop {number} app.SELECTION_MODE_TRANSLUCENT_SHELL=2 Selected objects are rendered with its own material, and the rest of the assembly is translucent. Internal objects are not displayed.
 * > #### __NOTE__
 * >
 * > To use the "translucent shell" object selection mode, you must set the {@link module:solo.app ENABLE_GLES3} 
 * > and {@link module:solo.app DISABLE_ANTIALIASING_GLES3} flags before the library is initialized.
 * >```
 * >    Cortona3DSolo.use('core', { 
 * >        features: 
 * >            Cortona3DSolo.app.ENABLE_GLES3 | 
 * >            Cortona3DSolo.app.DISABLE_ANTIALIASING_GLES3
 * >    });
 * >    Cortona3DSolo.app.initialize('scene.wrl');
 * >```
 * @typedef {number} SelectionModeEnum
 * @see {@link module:solo.app.selectionMode app.selectionMode}
 */

/**
 * Object property code.
 * @prop {number} app.PROPERTY_DIFFUSE_COLOR=0
 * @prop {number} app.PROPERTY_EMISSIVE_COLOR=1
 * @prop {number} app.PROPERTY_TRANSPARENCY=2
 * @prop {number} app.PROPERTY_VISIBILITY=3
 * @prop {number} app.PROPERTY_TRANSLATION=4
 * @prop {number} app.PROPERTY_ROTATION=5
 * @prop {number} app.PROPERTY_SCALE=6
 * @prop {number} app.PROPERTY_CLIP_PROTECTED=7
 * @typedef {number} ObjectProperty
 * @see {@link module:solo.app.setObjectPropertyf app.setObjectPropertyf()}
 */

/**
 * Metadata role code.
 * @prop {number} app.MR_PARTNUMBER=1
 * @prop {number} app.MR_PARTDESC=2
 * @prop {number} app.MR_ITEM=3
 * @prop {number} app.MR_ITEMVAR=4
 * @prop {number} app.MR_INDENT=5
 * @prop {number} app.MR_UPA=6
 * @prop {number} app.MR_TOTALQTY=7
 * @typedef {number} MetadataRoleCode
 * @see CatalogItemInfo
 */

/**
 * Mouse drag mode.
 * @prop {number} app.MOUSE_DRAG_MODE_SPIN=0
 * @prop {number} app.MOUSE_DRAG_MODE_PAN=1
 * @prop {number} app.MOUSE_DRAG_MODE_ZOOM=2
 * @prop {number} app.MOUSE_DRAG_MODE_DEFAULT=0 MOUSE_DRAG_MODE_SPIN
 * @typedef {number} MouseDragMode
 * @see {@link module:solo.app.setMouseDragMode app.setMouseDragMode()}
 * @deprecated since version 2.1.4, use {@link module:solo.app.navigator app.navigator} instead
 */

/**
 * A hexadecimal html-color string "#RRGGBB".
 * @typedef {string} HexColorString
 */

/**
 * A method parameter that sets the Animated transition mode.
 * - `true` - transition effect is on
 * - `false` - transition effect is off
 * @typedef {boolean} AnimatedMode
 */

/**
 * Name of standard view:
 * - `"front"`
 * - `"back"`
 * - `"left"`
 * - `"right"`
 * - `"top"`
 * - `"bottom"`
 * - `"isometric"`
 * @typedef {string} StandardViewName
 * @see {@link module:solo.app.jumpToStandardView app.jumpToStandardView()}
 */

/**
 * Information about the picked 3D object, for example:
 * ```
 * { 
 *     handle: 7210488, 
 *     name: "PPM005350_46" 
 * }
 * ```
 * @typedef {object} PickedObjectInfo
 * @prop {Handle} handle A handle of the picked 3D object.
 * @prop {string} name DEF name of the picked 3D object.
 * @see {@link module:solo.app.
 *  app.pickObject()}
 */

/**
 * Information about the picked chain of 3D objects, for example:
 * ```
 * { 
 *      coord: [
 *          -0.027441510930657387,
 *          -0.7154514789581299,
 *          -0.03601783514022827
 *      ], 
 *      normal: [
 *          -0.21847587823867798,
 *          -0.000531829718966037,
 *          -0.09742648154497146
 *      ],
 *      sceneCoord: [
 *          1.715429425239563,
 *          -0.028011199086904526,
 *          -0.03601783514022827
 *      ],
 *      sceneNormal: [
 *          0.0014959870604798197,
 *          -0.9133041501045227,
 *          -0.4072754681110382
 *      ],
 *      chain: [
 *          5698800, 6100248, 6100664, 6101200, 6101848
 *      ]
 * }
 * ```
 * @typedef {object} PickedObjectChain
 * @prop {number[]} coord The point on the surface of the picked geometry. An array of three numbers [x, y, z].
 * @prop {number[]} normal The vector of the normal to the surface of the picked geometry. An array of three numbers [x, y, z].
 * @prop {number[]} sceneCoord The point on the surface of the picked geometry in the global coordinates. An array of three numbers [x, y, z].
 * @prop {number[]} sceneNormal The vector of the normal to the surface of the picked geometry in the global coordinates. An array of three numbers [x, y, z].
 * @prop {Handle[]} chain An array of picked 3D objects. Starting with the root element of the scene.
 * @see {@link module:solo.app.pickObjectChain app.pickObjectChain()}
 * @see {@link module:solo.app.pickObjectChainWithRay app.pickObjectChainWithRay()}
 */

/**
 * Information about the ray in the form of an origin point and a direction vector.
 * ```
 * { 
 *      origin: [
 *          -0.027441510930657387,
 *          -0.7154514789581299,
 *          -0.03601783514022827
 *      ], 
 *      direction: [
 *          -0.21847587823867798,
 *          -0.000531829718966037,
 *          -0.09742648154497146
 *      ]
 * }
 * ```
 * @typedef {object} Ray
 * @prop {number[]} origin An origin point. An array of three numbers [x, y, z].
 * @prop {number[]} direction A direction vector. An array of three numbers [x, y, z].
 * @see {@link module:solo.app.pickObjectChainWithRay app.pickObjectChainWithRay()}
 * @see {@link module:solo.app.pickAllObjectChainsWithRay app.pickAllObjectChainsWithRay()}
 */

/**
 * Information about of the 3D object bounding box, for example:
 * ```
 * {
 *      center: [
 *          0.0024996697902679443,
 *          0.0038053393363952637,
 *          -0.21515682339668274
 *      ],
 *      size: [
 *          0.5102912783622742,
 *          0.5106911063194275,
 *          0.33653467893600464
 *      ]
 * }
 * ```
 * @typedef {object} ObjectBoundingBox
 * @prop {number[]} center Bounding box center. An array of three numbers [x, y, z].
 * @prop {number[]} size Bounding box size. An array of three numbers [x, y, z].
 * @see {@link module:solo.app.getObjectBoundingBox app.getObjectBoundingBox()}
 */

/**
 * Information about the 3D object "viewpoint", for example:
 * ```
 * { 
 *     handle: 5670488, 
 *     name: "",
 *     description: "Top"
 * }
 * ```
 * @typedef {object} ViewpointInfo
 * @prop {Handle} handle A handle of the 3D object "viewpoint".
 * @prop {string} name DEF name of the 3D object "viewpoint".
 * @prop {string} description Description string from the 3D object "viewpoint".
 * @see {@link module:solo.app.getViewpoints app.getViewpoints()}
 */

/**
 * Information about loaded document, for example:
 * ```
 * { 
 *      type: "ipc", 
 *      baseURL	"",
 *      companionFile: "pump-catalog.interactivity.xml",
 *      bundleURL: "http://.../pump-catalog.cortona3d",
 *      specificationName: "GENERIC_IPC",
 *      ...
 * }
 * ```
 * @typedef {DocumentCatalogInfo|DocumentProcedureInfo|DocumentGenericInfo|DocumentDrawingInfo} DocumentInfo
 * @prop {string} type - The type of the 3D model: 
 * - `"procedure"`
 * - `"ipc"`
 * - `"generic"`
 * - `"drawing"`
 * @prop {string} baseURL - A base path to the loaded file or the empty string if the model loaded from the bundle file.
 * @prop {string|null} bundleURL - The URL to the loaded bundle file *.cortona3d* or __null__ if the model is loaded not from the bundle. 
 * @prop {string} companionFile - The filename of the companion file *.interactivity.xml* in the loaded bundle or the URL if the model is loaded not from the bundle.
 * @prop {string} specificationName - Identifier of the specification component.
 * @see {@link module:solo.app.didFinishLoadDocument app.didFinishLoadDocument()}
 * @see {@link module:solo.app.modelInfo app.modelInfo}
 */

/**
 * Catalog information object, for example:
 * ```
 * {
 *      type: "ipc",
 *      baseURL: "http://.../",
 *      bundleURL: null,
 *      companionFile: "http://.../pump-catalog.interactivity.xml"
 *      specificationName: "GENERIC_IPC",
 *      sheet: {
 *          description: "Assembled View",
 *          dplTable: "<table id=\"dpl-table\" class=\"dpl-table\">..</table>",
 *          dplTableWidth: 69,
 *          drawing: "http://.../pump-catalog-1.svg",
 *          id: "view_0"
 *      },
 *      sheets: [
 *          {
 *              description: "Assembled View",
 *              drawing: "http://.../pump-catalog-1.svg"
 *              id: "view_0",
 *              indentationLevel: 0
 *          },
 *          ...
 *      ]
 * }
 * ```
 * @prop {string} type=ipc - See {@link DocumentInfo}
 * @prop {string} baseURL - See {@link DocumentInfo}
 * @prop {string|null} bundleURL - See {@link DocumentInfo}
 * @prop {string} companionFile - See {@link DocumentInfo}
 * @prop {string} specificationName - See {@link DocumentInfo}
 * @prop {CatalogCurrentSheetInfo} sheet - The object represents information about the first IPC sheet.
 * @prop {CatalogSheetInfo[]} sheets - An array of objects represents information about IPC sheets.
 * @typedef {object} DocumentCatalogInfo
 * @see DocumentInfo
 */

/**
 * Drawing information object, for example:
 * ```
 * {
 *      type:	"drawing",
 *      baseURL: "http://.../"
 * }
 * ```
 * @prop {string} type=drawing - See {@link DocumentInfo}
 * @prop {string} baseURL - A base path to the loaded image file. See {@link DocumentInfo}.
 * @typedef {object} DocumentDrawingInfo
 * @see DocumentInfo
 */

/**
 * Generic VRML information object, for example:
 * ```
 * {
 *      type:	"generic"
 *      baseURL: "http://.../",
 * }
 * ```
 * @prop {string} type=generic - See {@link DocumentInfo}.
 * @prop {string} baseURL - A base path to the loaded VRML file. See {@link DocumentInfo}.
 * @typedef {object} DocumentGenericInfo
 * @see DocumentInfo
 */

/**
 * Procedure information object, for example:
 * ```
 * doc = {
 *      type: "procedure",
 *      baseURL: "",
 *      bundleURL	"http://.../pump-catalog.cortona3d",
 *      companionFile: "pump-procedure.interactivity.xml",
 *      specificationName: "GENERIC_PRC",
 *      duration: 71.45999908447265,
 *      autoStartPlayback: 0,
 *      comments: "<div class=\"tiramisu-proc-title\">...</div>"
 * }
 * ```
 * @prop {string} type=procedure - See {@link DocumentInfo}.
 * @prop {string} baseURL - See {@link DocumentInfo}.
 * @prop {string|null} bundleURL - See {@link DocumentInfo}.
 * @prop {string} companionFile - See {@link DocumentInfo}.
 * @prop {string} specificationName - See {@link DocumentInfo}.
 * @prop {number} duration - The duration of the interactive procedure in seconds.
 * @prop {number} autoStartPlayback - Automatic start of the procedure playback:
 * - `0` - auto start is off
 * - `1` - auto start is on
 * @prop {string} comments - The HTML string represents a textual description of the procedure steps.
 * @typedef {object} DocumentProcedureInfo
 * @see DocumentInfo
 */

/**
 * The hook method is invoked when the Cortona3D Solo core will be loaded and initialized.
 * 
 * @memberof module:solo.app
 * @abstract 
 * @function onReady
 * @see The corresponding event {@link event:"app.onReady" "app.onReady"}
 */
/**
 * @event "app.onReady"
 * @see The corresponding hook method {@link module:solo.app.onReady app.onReady()}
 */

/**
 *  The hook method is invoked when the 3D scene is loaded.
 *  
 * @memberof module:solo.app
 * @abstract 
 * @function didFinishLoadDocument
 * @param {DocumentInfo} modelInfo - Information object depending on the type of loaded interactive scene. 
 * @see {@link module:solo.app.modelInfo app.modelInfo}
 * @see The corresponding event {@link event:"app.didFinishLoadDocument" "app.didFinishLoadDocument"}
 */
/**
 * @event "app.didFinishLoadDocument"
 * @see The corresponding hook method {@link module:solo.app.didFinishLoadDocument app.didFinishLoadDocument()}
 */

/**
 *  The hook method is invoked when 3D scene is ready for rendering the first frame.
 * 
 * @memberof module:solo.app
 * @abstract 
 * @function firstFrameDidArrive
 * @param {number} timestamp
 * @see The corresponding event {@link event:"app.firstFrameDidArrive" "app.firstFrameDidArrive"}
 */
/**
 * @event "app.firstFrameDidArrive"
 * @see The corresponding hook method {@link module:solo.app.firstFrameDidArrive app.firstFrameDidArrive()}
 */

/**
 *  The hook method is invoked when 3D scene is failed to load.
 * 
 * @memberof module:solo.app
 * @abstract 
 * @function didFailLoadDocument
 * @param {string} message Reason
 * @see The corresponding event {@link event:"app.didFailLoadDocument" "app.didFailLoadDocument"}
 */
/**
 * @event "app.didFailLoadDocument"
 * @see The corresponding hook method {@link module:solo.app.didFailLoadDocument app.didFailLoadDocument()}
 */

/**
 * The hook method is invoked when anchor in the 3D scene is clicked.
 * 
 * @memberof module:solo.app
 * @abstract 
 * @function didClickHyperlink
 * @param {string[]} urls - Array of strings 
 * @see The corresponding event {@link event:"app.didClickHyperlink" "app.didClickHyperlink"}
 */
/**
 * @event "app.didClickHyperlink"
 * @see The corresponding hook method {@link module:solo.app.didClickHyperlink app.didClickHyperlink()}
 */

/**
 * The hook method is invoked when 3D objects change their visibility in the scene.
 * 
 * @memberof module:solo.app
 * @abstract 
 * @function didChangeVisibility
 * @param {Handle[]} shownHandles - an array of 3D object handles
 * @param {Handle[]} hiddenHandles - an array of 3D object handles
 * @see The corresponding event {@link event:"app.didChangeVisibility" "app.didChangeVisibility"}
 * @see {@link module:solo.app.observeObjectVisibility app.observeObjectVisibility}
 * @see {@link module:solo.app.cancelVisibilityObservation app.cancelVisibilityObservation}
 * @since 2.6.1
 */
/**
 * @event "app.didChangeVisibility"
 * @see The corresponding hook method {@link module:solo.app.didChangeVisibility app.didChangeVisibility()}
 * @since 2.6.1
 */

/**
 * The hook method is invoked when the navigation in the 3D window is started.
 * 
 * @memberof module:solo.app
 * @abstract 
 * @function willStartNavigateInScene
 * @see The corresponding event {@link event:"app.willStartNavigateInScene" "app.willStartNavigateInScene"}
 */
/**
 * @event "app.willStartNavigateInScene"
 * @see The corresponding hook method {@link module:solo.app.willStartNavigateInScene app.willStartNavigateInScene()}
 */

/**
 * The hook method is invoked to indicate that loading operation is in progress.
 * When the download is complete, the parameter `total` is -1.
 * 
 * @memberof module:solo.app
 * @abstract 
 * @function onProgress 
 * @param {number} position The amount of data currently transferred
 * @param {number} total The total amount of data to be transferred
 * @param {string} type The event's type:
 * - "progress"
 * - "load"
 * - "error"
 * - "abort"
 * @see The corresponding event {@link event:"app.onProgress" "app.onProgress"}
 */
/**
 * @event "app.onProgress"
 * @see The corresponding hook method {@link module:solo.app.onProgress app.onProgress()}
 */

/**
 * The hook method is invoked when context menu is called in the 3D window. 
 * The mouse uses secondary button click. The touch device uses long tap.
 * 
 * @memberof module:solo.app
 * @abstract 
 * @function didCallContextMenu
 * @param {number} offsetX The X coordinate relative to the target element 
 * @param {number} offsetY The Y coordinate relative to the target element 
 * @param {HTMLElement} target  Target element (`<canvas>`)
 * @see {@link module:solo.core.canvas core.canvas}
 * @see The corresponding event {@link event:"app.didCallContextMenu" "app.didCallContextMenu"}
 */
/**
 * @event "app.didCallContextMenu"
 * @see The corresponding hook method {@link module:solo.app.didCallContextMenu app.didCallContextMenu()}
 */

/**
 * The hook method is invoked when double-clicking in the 3D window.
 * 
 * @memberof module:solo.app
 * @abstract 
 * @function didDoubleClick
 * @param {Handle} handle
 * @param {number} offsetX The X coordinate relative to the target element 
 * @param {number} offsetY The Y coordinate relative to the target element 
 * @param {object} event - Source PointerEvent or MouseEvent object
 * @see The corresponding event {@link event:"app.didDoubleClick" "app.didDoubleClick"}
 * @since 2.1.0
 */
/**
 * @event "app.didDoubleClick"
 * @see The corresponding hook method {@link module:solo.app.didDoubleClick app.didDoubleClick()}
 */

/**
 * The hook method is invoked when selection of 3D objects is changed in the 3D window. 
 * 
 * @memberof module:solo.app
 * @abstract 
 * @function didChangeSelectedObjects
 * @see {@link module:solo.core.app.setSelectedObjects app.setSelectedObjects()}
 * @see {@link module:solo.core.app.addSelectedObjects app.addSelectedObjects()}
 * @see The corresponding event {@link event:"app.didChangeSelectedObjects" "app.didChangeSelectedObjects"}
 * @since 2.0.0
 */
/**
 * @event "app.didChangeSelectedObjects"
 * @see The corresponding hook method {@link module:solo.app.didChangeSelectedObjects app.didChangeSelectedObjects()}
 */

/**
 * The hook method is invoked when changing 3D objects under the cursor in the 3D window. 
 * 
 * @memberof module:solo.app
 * @abstract 
 * @function didChangeHoveredObjects
 * @see {@link module:solo.core.app.setHoveredObjects app.setHoveredObjects()}
 * @see {@link module:solo.core.app.addHoveredObjects app.addHoveredObjects()}
 * @see The corresponding event {@link event:"app.didChangeHoveredObjects" "app.didChangeHoveredObjects"}
 * @since 2.0.0
 */
/**
 * @event "app.didChangeHoveredObjects"
 * @see The corresponding hook method {@link module:solo.app.didChangeHoveredObjects app.didChangeHoveredObjects()}
 */

/**
 * The object with key/value pairs, for example:
 * ```
 * {
 *     C3DCOLLECTION: "Generic IPC",
 *     TITLE: "Pump IPC - Complete"
 * }
 * ```
 * @typedef {object} KeyValuePairs
 */

/**
 * The object visibility code.
 * @prop {number} app.OBJECT_VISIBILITY_VISIBLE=0
 * @prop {number} app.OBJECT_VISIBILITY_HIDDEN=1
 * @prop {number} app.OBJECT_VISIBILITY_TRANSPARENT=2
 * @prop {number} app.OBJECT_VISIBILITY_IMPLICITLY_HIDDEN=3
 * @typedef {number} ObjectVisibilityEnum
 * @see {@link module:solo.app.getObjectVisibility app.getObjectVisibility()}
 */

/**
 * The navigator action code.
 * @prop {number} app.NAVIGATOR_ACTION_SPIN=0
 * @prop {number} app.NAVIGATOR_ACTION_PAN=1
 * @prop {number} app.NAVIGATOR_ACTION_ZOOM=2
 * @prop {number} app.NAVIGATOR_ACTION_ROTATE=3
 * @typedef {number} NavigatorActionEnum
 * @see {@link module:solo.app.navigate app.navigate()}
 * @deprecated since version 2.1.4, use {@link module:solo.app.navigator app.navigator} instead
 */

/**
 * The navigator options flags.
 * 
 * > #### __NOTE__
 * >
 * > Using flags {@link NavigatorOptionsFlags AUTOMATIC_ZOOM_ANCHOR} and {@link NavigatorOptionsFlags AUTOMATIC_SPIN_CENTER} requires using of the {@link module:solo.app DISABLE_DISCARDABLE_GEOMETRY_DATA} flag when initializing the library.
 * >```
 * >    Cortona3DSolo.use('core', { 
 * >        features: Cortona3DSolo.app.DISABLE_DISCARDABLE_GEOMETRY_DATA
 * >    });
 * >```
 * 
 * @prop {number} app.AUTOMATIC_ZOOM_ANCHOR=1 - The point under the mouse cursor is used as the zoom anchor. See note.
 * @prop {number} app.AUTOMATIC_SPIN_CENTER=2 - The point under the mouse cursor is used as the spin center. See note.
 * @prop {number} app.DISABLE_ZOOM_SCALE_LIMITS=4 - Disables zoom scale limits.
 * @prop {number} app.LOCK_ROTATION_CENTER=8 - Locks the center of rotation when panning.
 * @prop {number} app.DISABLE_NAVIGATION=16 - Disables navigation in the 3D window.
 * @typedef {number} NavigatorOptionsFlags
 * @see {@link module:solo.app.navigatorOptions app.navigatorOptions}
 * @deprecated since version 2.1.4, use {@link module:solo.app.navigator app.navigator} instead
 */

/**
 * Snapshot options flags.
 * 
 * @prop {number} app.SNAPSHOT_DEFAULT=0
 * @prop {number} app.SNAPSHOT_UNDO_FIELD_VALUE_CHANGES=1 - Temporary cancellation of changes made with {@link module:solo.app.setObjectPropertyf app.setObjectPropertyf()}
 * @prop {number} app.SNAPSHOT_USE_CURRENT_CAMERA_ORIENTATION=2 - The orientation parameter is ignored and rendering takes place from the current camera orientation.
 * @prop {number} app.SNAPSHOT_REVEAL_HIDDEN_OBJECTS=4 - Show hidden objects.
 * @prop {number} app.SNAPSHOT_USE_SCENE_CAMERA=8 Disables the fit and creates a snapshot from the current camera position.
 * @prop {number} app.SNAPSHOT_USE_SCENE_BACKGROUND=16 Uses the background of the scene for a snapshot.
 * @typedef {number} SnapshotFlags
 * @see {@link module:solo.app.makeSnapshot app.makeSnapshot()}
 */

/**
 * Flags of query options to determine the occlusion of objects.
 * 
 * @prop {number} app.QUERY_OBJECT_OCCLUSION_IMMEDIATE_PARENT=0x100
 * @prop {number} app.QUERY_OBJECT_OCCLUSION_TOP_LEVEL_PARENT=0x200
 * @typedef {number} QueryObjectOcclusionFlags
 * @see {@link module:solo.app.queryObjectOcclusion app.queryObjectOcclusion()}
 */

/**
 * Flags of query options to determine the occlusion of objects.
 * 
 * @prop {number} app.INCLUDE_HIDDEN_CONTEXT_GEOMETRY=1
 * @prop {number} app.INCLUDE_ISOLATED_SELECTED_OBJECTS=2
 * @typedef {number} QueryObjectVisibilityFlags
 * @see {@link module:solo.app.getObjectVisibility app.getObjectVisibility()}
 */

/**
 * The type of the highlighted object.
 * @prop {number} app.OBJECT_HIGHLIGHT_HOVERED=0
 * @prop {number} app.OBJECT_HIGHLIGHT_SELECTED=1
 * @prop {number} app.OBJECT_HIGHLIGHT_SELECTED_HOVERED=2
 * @typedef {number} ObjectHighlightEnum
 * @see {@link module:solo.app.setObjectHighlightParams app.setObjectHighlightParams()}
 * @see {@link module:solo.app.getObjectHighlightParams app.getObjectHighlightParams()}
 */

/**
 * 3D object highlight parameters, for example:
 * ```
 * {
 *      diffuseColor: '#808000',
 *      diffuseBrightnessDelta: 0.5,
 *      emissiveColor: '#888888',
 *      emissiveBrightnessDelta: -1,
 *      transparency: 0
 * }
 * ```
 * @prop {HexColorString} diffuseColor 
 * @prop {number} diffuseBrightnessDelta - [-1...1]
 * @prop {HexColorString} emissiveColor 
 * @prop {number} emissiveBrightnessDelta - [-1...1]
 * @prop {number} transparency - [-1...1] -1 opaque, 0 as is, 1 transparent
 * @typedef {object} ObjectHighlightParams
 * @see {@link module:solo.app.setObjectHighlightParams app.setObjectHighlightParams()}
 * @see {@link module:solo.app.getObjectHighlightParams app.getObjectHighlightParams()}
 */

/**
 * Light source configuration:
 * ```
 * {
 *      color: '#FFFFFF',
 *      direction: [0, 0, -1],
 *      intensity: 0.8,
 *      ambientIntensity: 0
 * }
 * ```
 * @prop {HexColorString} color
 * @prop {number[]} direction - [x, y, z]
 * @prop {number} intensity - [0...1]
 * @prop {number} ambientIntensity - [0...1]
 * @typedef {object} LightingConfig
 * @see {@link module:solo.app.lightingConfig app.lightingConfig}
 */

/**
 * The object with results of a query to determine the occlusion of objects:
 * ```
 * {
 *      handle: number_of_visible_points,
 *      ...
 * }
 * ```
 * For example:
 * ```
 * {
 *      7434056: 18572,
 *      8826176: 20,
 *      8880368: 8,
 *      8898608: 1,
 *      8901344: 55 
 * }
 * ```
 * @typedef {object} QueryObjectOcclusionResult
 * @see {@link module:solo.app.queryObjectOcclusion app.queryObjectOcclusion()}
 */

/**
 * Context geometry rendering modes.
 * @prop {number} app.GEOMETRY_RENDERING_HIDDEN=-1 The geometry is not rendered.
 * @prop {number} app.GEOMETRY_RENDERING_DEFAULT=0 The geometry is rendered as is.
 * @prop {number} app.GEOMETRY_RENDERING_XRAY=1 The geometry is rendered translucent and monochrome.
 * @prop {number} app.GEOMETRY_RENDERING_TRANSLUCENT_SHELL=2 The geometry is rendered translucent. Internal objects are not displayed.
 * > #### __NOTE__
 * >
 * > To use the "translucent shell" rendering mode, you must set the {@link module:solo.app ENABLE_GLES3} 
 * > and {@link module:solo.app DISABLE_ANTIALIASING_GLES3} flags before the library is initialized.
 * >```
 * >    Cortona3DSolo.use('core', { 
 * >        features: 
 * >            Cortona3DSolo.app.ENABLE_GLES3 | 
 * >            Cortona3DSolo.app.DISABLE_ANTIALIASING_GLES3
 * >    });
 * >    Cortona3DSolo.app.initialize('scene.wrl');
 * >```
 * @typedef {number} GeometryRenderingModeEnum
 * @see {@link module:solo.app.backgroundGeometryRenderingMode app.backgroundGeometryRenderingMode}
 */

